export const DEMO_AGENTIC_WORKFLOW_ID2 = 'f25c1316-f6ca-4708-8ad4-71b00a972faa';

export const DATA_AGENTIC_LOGS2 = [
  {
    type: 'default',
    message: '🚀 Starting Big Data Quality Agent',
    timestamp: '2025-06-25 08:01:37.420629',
  },
  {
    type: 'default',
    message: '📊 Optimized for large datasets with 500+ columns',
    timestamp: '2025-06-25 08:01:37.580255',
  },
  {
    type: 'default',
    message: '⚡ Using column-by-column processing with feedback loops',
    timestamp: '2025-06-25 08:01:37.593583',
  },
  {
    type: 'default',
    message: '🔄 Starting agent-orchestrated workflow execution...',
    timestamp: '2025-06-25 08:02:06.155460',
  },
  {
    type: 'default',
    message: '🚀 Starting agent-orchestrated big data quality assessment',
    timestamp: '2025-06-25 08:02:06.240673',
  },
  {
    type: 'default',
    message: '🔍 Delegating to ProfilingAgent...',
    timestamp: '2025-06-25 08:02:06.257932',
  },
  {
    type: 'default',
    message: '✅ ProfilingAgent completed: 1471884 rows with 19 columns',
    timestamp: '2025-06-25 08:05:36.984599',
  },
  {
    type: 'default',
    message: '📝 Delegating to ColumnWiseRuleGeneratorAgent...',
    timestamp: '2025-06-25 08:05:37.075221',
  },
  {
    type: 'default',
    message: '🤖 ColumnWiseRuleGeneratorAgent: Processing 19 columns',
    timestamp: '2025-06-25 08:05:37.087920',
  },
  {
    type: 'default',
    message: '🔄 Starting column-by-column rule generation for 19 columns',
    timestamp: '2025-06-25 08:05:43.888459',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_record_id',
    timestamp: '2025-06-25 08:05:43.976069',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_record_id',
    timestamp: '2025-06-25 08:06:30.409856',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_record_id',
    timestamp: '2025-06-25 08:06:33.237893',
  },
  {
    type: 'default',
    message: '  - EnergyRecordId_FormatValidation: Validates that Energy_record_id follows the pattern EN#####:',
    timestamp: '2025-06-25 08:06:33.253161',
  },
  {
    type: 'default',
    message: '  - EnergyRecordId_UniqueValidation: Detects duplicate Energy_record_id values:',
    timestamp: '2025-06-25 08:06:33.265777',
  },
  {
    type: 'default',
    message:
      "  - EnergyRecordId_CrossColumnConsistency: Checks for consistent Energy_record_id across related columns 'Month', 'Energy_Facility', 'Energy_Type':",
    timestamp: '2025-06-25 08:06:33.278559',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: EnergyRecordId_FormatValidation',
    timestamp: '2025-06-25 08:06:33.291527',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: EnergyRecordId_FormatValidation',
    timestamp: '2025-06-25 08:06:33.303961',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: EnergyRecordId_FormatValidation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:06:41.642553',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:06:41.725931',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:06:41.743570',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to validate a format where 'Energy_record_id' should follow the pattern EN#####. However, based on the provided sample values and setting unique values percentage to 0%, it appears that all values follow the same pattern 'EN00001'. Due to the lack of variation, this rule doesn't add value in identifying data quality issues and seems redundant. Additionally, if the unique values are indeed 0.0%, the rule wouldn't catch any invalid entries because all values are the same, indicating a potential misunderstanding of the column's uniqueness profile or data quality issue.",
    timestamp: '2025-06-25 08:06:56.893900',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:06:56.976246',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: EnergyRecordId_FormatAndUniquenessValidation',
    timestamp: '2025-06-25 08:06:59.538716',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:07:10.392844',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: EnergyRecordId_FormatAndUniquenessValidationRefined',
    timestamp: '2025-06-25 08:07:13.367036',
  },
  {
    type: 'default',
    message:
      "    New code: from pyspark.sql.functions import col, count, countDistinct\n\ntotal_count = df.count()\nunique_ids_count = df.select(col('Energy_record_id')).distinct().count()\nunique_percentage = (unique_ids_count / total_count) * 100\n\ninvalid_format_df = df.filter(~col('Energy_record_id').rlike('^EN\\d{5}$'))\nnon_unique_threshold = (unique_percentage < 99.0)\n\nif non_unique_threshold:\n    non_unique_ids = df.groupBy('Energy_record_id').count().filter(col('count') > 1).select('Energy_record_id')\n    issues_df = invalid_format_df.union(df.join(non_unique_ids, 'Energy_record_id'))\nelse:\n    issues_df = invalid_format_df\n\nresult_df = issues_df",
    timestamp: '2025-06-25 08:07:13.385303',
  },
  {
    type: 'default',
    message:
      '    New description: Validates that Energy_record_id follows the pattern EN##### and ensures each ID is unique in the dataset by checking if at least 99% of IDs are unique.',
    timestamp: '2025-06-25 08:07:13.400657',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: EnergyRecordId_FormatAndUniquenessValidationRefined',
    timestamp: '2025-06-25 08:07:13.414071',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:07:38.376953',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'EnergyRecordId_FormatAndUniquenessValidationRefined' - quality score below 80%",
    timestamp: '2025-06-25 08:07:38.517651',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: EnergyRecordId_UniqueValidation',
    timestamp: '2025-06-25 08:07:38.534549',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: EnergyRecordId_UniqueValidation',
    timestamp: '2025-06-25 08:07:38.549071',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.99%',
    timestamp: '2025-06-25 08:07:47.292621',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:07:47.378983',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 99.99% and passed common sense check',
    timestamp: '2025-06-25 08:08:01.046587',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: EnergyRecordId_UniqueValidation',
    timestamp: '2025-06-25 08:08:01.133273',
  },
  {
    type: 'rule',
    message: 'Detects duplicate Energy_record_id values',
    timestamp: '2025-06-25 08:08:01.148109',
  },
  {
    type: 'code',
    message: "result_df = df.groupBy('Energy_record_id').count().filter(col('count') > 1)",
    timestamp: '2025-06-25 08:08:01.164103',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: EnergyRecordId_CrossColumnConsistency',
    timestamp: '2025-06-25 08:08:01.178947',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: EnergyRecordId_CrossColumnConsistency',
    timestamp: '2025-06-25 08:08:01.254037',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: EnergyRecordId_CrossColumnConsistency. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:08:10.921760',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:08:11.005351',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:08:11.018059',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to check cross-column consistency of 'Energy_record_id' with columns 'Month', 'Energy_Facility', and 'Energy_Type'. However, the 'Energy_record_id' column has a Null Percentage of 0.0% and Unique Values Percentage of 0.0%. Since all entries are the same, cross-column consistency checking doesn't make sense because there are no variations or uniqueness in the 'Energy_record_id' column. Thus, there will always be consistency unless the other related columns have errors. The current rule seems overly strict and not aligned with the data characteristics.",
    timestamp: '2025-06-25 08:08:24.676694',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:08:24.771893',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: EnergyRecordId_CrossColumnConsistency_Refined',
    timestamp: '2025-06-25 08:08:26.227094',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: EnergyRecordId_CrossColumnConsistency_Refined. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:08:38.236869',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:08:38.320554',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:08:38.335051',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule aims to check for variations of 'Month', 'Energy_Facility', and 'Energy_Type' for the same 'Energy_record_id'. However, based on the data characteristics, where all 'Energy_record_id' values are identical, there's little point in applying such a rule. The absence of unique 'Energy_record_id' values means no opportunity for variation across related columns exists in the sample data.",
    timestamp: '2025-06-25 08:08:52.464396',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:08:52.547499',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: EnergyRecordId_UniformityCheck',
    timestamp: '2025-06-25 08:08:53.725190',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:09:02.523558',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:09:02.659135',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:09:18.407956',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Facility',
    timestamp: '2025-06-25 08:09:18.422506',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule aims to ensure that for a given set of 'Month', 'Energy_Facility', and 'Energy_Type' the 'Energy_record_id' should remain constant, as specified by the rule. The problem is that when 'Energy_record_id' values are identical across the dataset, the code logic will always result in zero 'unique_ids'. Thus, the rule will not capture any meaningful data quality issues, since the provided sample values all have the same 'Energy_record_id'. Moreover, the unique values percentage being 0.0% implies there is no variability in the 'Energy_record_id', further indicating that the rule is not applicable for this data characteristic.",
    timestamp: '2025-06-25 08:09:18.324721',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Facility',
    timestamp: '2025-06-25 08:10:07.166883',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Facility',
    timestamp: '2025-06-25 08:10:11.212154',
  },
  {
    type: 'default',
    message:
      '  - Energy_Facility_Length_Validation: Ensures that the Energy_Facility values do not exceed 50 characters in length.:',
    timestamp: '2025-06-25 08:10:11.226369',
  },
  {
    type: 'default',
    message:
      "  - Energy_Facility_Consistency_with_Material_type: Checks that 'Energy_Facility' is consistent with 'Material_type'. If 'Material_type' is 'Crude input', the only valid 'Energy_Facility' is 'Gujarat Refinery'.:",
    timestamp: '2025-06-25 08:10:11.240721',
  },
  {
    type: 'default',
    message:
      "  - Energy_Facility_Uniqueness_Check: Ensures that the 'Energy_Facility' column has only one unique value across all records.:",
    timestamp: '2025-06-25 08:10:11.254128',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Facility_Length_Validation',
    timestamp: '2025-06-25 08:10:11.269257',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Facility_Length_Validation',
    timestamp: '2025-06-25 08:10:11.284090',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Energy_Facility_Length_Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:10:18.881589',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:10:18.961082',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:10:18.973834',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:10:32.264772',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Facility_Length_Validation',
    timestamp: '2025-06-25 08:10:32.353166',
  },
  {
    type: 'rule',
    message: 'Ensures that the Energy_Facility values do not exceed 50 characters in length.',
    timestamp: '2025-06-25 08:10:32.450455',
  },
  {
    type: 'code',
    message: "result_df = df.filter(length(col('Energy_Facility')) > 50)",
    timestamp: '2025-06-25 08:10:32.465120',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Facility_Consistency_with_Material_type',
    timestamp: '2025-06-25 08:10:32.480666',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Facility_Consistency_with_Material_type',
    timestamp: '2025-06-25 08:10:32.494422',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 96.75%',
    timestamp: '2025-06-25 08:10:39.642381',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:10:39.732901',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 96.75% and passed common sense check',
    timestamp: '2025-06-25 08:10:52.956233',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Facility_Consistency_with_Material_type',
    timestamp: '2025-06-25 08:10:53.033810',
  },
  {
    type: 'rule',
    message:
      "Checks that 'Energy_Facility' is consistent with 'Material_type'. If 'Material_type' is 'Crude input', the only valid 'Energy_Facility' is 'Gujarat Refinery'.",
    timestamp: '2025-06-25 08:10:53.047511',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Material_type') == 'Crude input') & (col('Energy_Facility') != 'Gujarat Refinery'))",
    timestamp: '2025-06-25 08:10:53.058524',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Facility_Uniqueness_Check',
    timestamp: '2025-06-25 08:10:53.071879',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Facility_Uniqueness_Check',
    timestamp: '2025-06-25 08:10:53.084078',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:10:56.293472',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Facility_Uniqueness_Check_Refined',
    timestamp: '2025-06-25 08:10:57.975042',
  },
  {
    type: 'default',
    message:
      "    New code: is_unique = df.select(countDistinct(col('Energy_Facility'))).collect()[0][0] == 1; result_df = df.filter(col('Energy_Facility').isNotNull() & lit(not is_unique))",
    timestamp: '2025-06-25 08:10:57.988807',
  },
  {
    type: 'default',
    message:
      "    New description: Verifies that the 'Energy_Facility' column contains primarily a unique value across all records, with the allowance to flag if there is more than one unique value.",
    timestamp: '2025-06-25 08:10:58.001563',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Facility_Uniqueness_Check_Refined',
    timestamp: '2025-06-25 08:10:58.014183',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:11:09.836171',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Facility_Uniqueness_Check_Lenient',
    timestamp: '2025-06-25 08:11:11.768861',
  },
  {
    type: 'default',
    message:
      "    New code: total_records = df.count(); unique_count = df.select(countDistinct(col('Energy_Facility'))).collect()[0][0]; variance_threshold = int(total_records * 0.05); is_predominantly_unique = unique_count <= variance_threshold + 1; result_df = df.filter(col('Energy_Facility').isNotNull() & lit(not is_predominantly_unique))",
    timestamp: '2025-06-25 08:11:11.783827',
  },
  {
    type: 'default',
    message:
      "    New description: Checks that the 'Energy_Facility' column predominantly contains a single unique value, but allows for up to 5% variance in uniqueness based on total records.",
    timestamp: '2025-06-25 08:11:11.796963',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Facility_Uniqueness_Check_Lenient',
    timestamp: '2025-06-25 08:11:11.810545',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Energy_Facility_Uniqueness_Check_Lenient. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:11:22.233528',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:11:22.359169',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:11:22.379003',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to ensure that the 'Energy_Facility' column predominantly contains a single unique value but allows for a 5% variance. However, the context and sample data provided indicate that the column is expected to have the same value ('Gujarat Refinery') for every record, as demonstrated by the unique values percentage and example values. This means the column is inherently not expected to have diversity in unique values. The rule seems unnecessary for a column where 0% unique values is acceptable, suggesting a structural or constant attribute about the data rather than needing validation of uniqueness. Additionally, allowing for up to 5% variance in a context where 0% uniqueness is the baseline seems logically inconsistent.",
    timestamp: '2025-06-25 08:11:36.604177',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:11:36.714207',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Type',
    timestamp: '2025-06-25 08:11:36.784166',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Type',
    timestamp: '2025-06-25 08:12:26.231842',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Type',
    timestamp: '2025-06-25 08:12:29.853119',
  },
  {
    type: 'default',
    message:
      "  - Energy_Type Enum Validation: Ensure Energy_Type is always 'Fuel Consumption', given the unique values percentage is 0.0%:",
    timestamp: '2025-06-25 08:12:29.868558',
  },
  {
    type: 'default',
    message:
      "  - Cross-Column Consistency with Energy_Fuel_Type: Ensure Energy_Type 'Fuel Consumption' implies a non-null and consistent value in Energy_Fuel_Type column:",
    timestamp: '2025-06-25 08:12:29.882110',
  },
  {
    type: 'default',
    message:
      "  - Energy_Type and Scope Relationship: Verify that Energy_Type 'Fuel Consumption' is appropriately linked with 'Scope 1 – Combustion':",
    timestamp: '2025-06-25 08:12:29.896305',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Type Enum Validation',
    timestamp: '2025-06-25 08:12:29.909831',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Type Enum Validation',
    timestamp: '2025-06-25 08:12:29.928076',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Energy_Type Enum Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:12:38.038420',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:12:38.127660',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:12:38.143875',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:12:53.497569',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Type Enum Validation',
    timestamp: '2025-06-25 08:12:53.582896',
  },
  {
    type: 'rule',
    message: "Ensure Energy_Type is always 'Fuel Consumption', given the unique values percentage is 0.0%",
    timestamp: '2025-06-25 08:12:53.598954',
  },
  {
    type: 'code',
    message: "result_df = df.filter(col('Energy_Type') != 'Fuel Consumption')",
    timestamp: '2025-06-25 08:12:53.616117',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Cross-Column Consistency with Energy_Fuel_Type',
    timestamp: '2025-06-25 08:12:53.632001',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Cross-Column Consistency with Energy_Fuel_Type',
    timestamp: '2025-06-25 08:12:53.647282',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Cross-Column Consistency with Energy_Fuel_Type. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:13:01.015730',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:13:01.099351',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:13:01.115312',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to filter rows where 'Energy_Type' is 'Fuel Consumption' and 'Energy_Fuel_Type' is either null or empty. However, given the column context, 'Energy_Type' is always 'Fuel Consumption', and its null percentage and unique values percentage are both 0.0%. This indicates there is no variation in the data, making the rule essentially redundant. The rule description does not match the logic since it suggests ensuring consistency, but the code merely filters out problematic rows without enforcing consistency. Finally, the rule might not identify genuine data quality issues because it doesn't resolve the inconsistency or provide corrective action.",
    timestamp: '2025-06-25 08:13:15.078385',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:13:15.159506',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Consistent Energy_Fuel_Type for Fuel Consumption',
    timestamp: '2025-06-25 08:13:16.814535',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Consistent Energy_Fuel_Type for Fuel Consumption. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:13:26.189611',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:13:26.295212',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:13:26.313124',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:13:40.149690',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Consistent Energy_Fuel_Type for Fuel Consumption',
    timestamp: '2025-06-25 08:13:40.226810',
  },
  {
    type: 'rule',
    message:
      "Ensure that when Energy_Type is 'Fuel Consumption', Energy_Fuel_Type should have a non-null, non-empty, and consistent known value, flagging inconsistent entries for review.",
    timestamp: '2025-06-25 08:13:40.241881',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Energy_Type') == 'Fuel Consumption') & (isnull(col('Energy_Fuel_Type')) | (col('Energy_Fuel_Type') == '') | (col('Energy_Fuel_Type') == 'Unknown')))",
    timestamp: '2025-06-25 08:13:40.254990',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Type and Scope Relationship',
    timestamp: '2025-06-25 08:13:40.267430',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Type and Scope Relationship',
    timestamp: '2025-06-25 08:13:40.278976',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Energy_Type and Scope Relationship. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:13:48.153866',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:13:48.262729',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:13:48.276482',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to ensure that the 'Energy_Type' value 'Fuel Consumption' aligns exclusively with 'Scope 1 – Combustion'. However, given that the example data shows only 'Fuel Consumption' for 'Energy_Type' with no variation, and that the rule flags records where 'Scope' is not 'Scope 1 – Combustion', it seems the dataset might not have the required variability to assess this rule adequately. Furthermore, there is no context to determine if 'Scope 1 – Combustion' is indeed the only valid scope for 'Fuel Consumption', raising concerns that the logic might be overly strict or based on incorrect assumptions.",
    timestamp: '2025-06-25 08:14:02.808555',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:14:02.887035',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Refined Energy_Type and Scope Validation',
    timestamp: '2025-06-25 08:14:03.935254',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Refined Energy_Type and Scope Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:14:12.029497',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:14:12.211493',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:14:12.228848',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:14:26.163463',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Refined Energy_Type and Scope Validation',
    timestamp: '2025-06-25 08:14:26.247754',
  },
  {
    type: 'rule',
    message:
      "Ensure that Energy_Type 'Fuel Consumption' is linked primarily with 'Scope 1 – Combustion', but allow validation if 'Scope' has appropriate alternatives.",
    timestamp: '2025-06-25 08:14:26.260397',
  },
  {
    type: 'code',
    message:
      "valid_scopes = ['Scope 1 – Combustion', 'Scope 2 – Gas']\nresult_df = df.filter((col('Energy_Type') == 'Fuel Consumption') & (~col('Scope').isin(valid_scopes)))",
    timestamp: '2025-06-25 08:14:26.273180',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Fuel_Type',
    timestamp: '2025-06-25 08:14:26.286813',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Fuel_Type',
    timestamp: '2025-06-25 08:15:11.999398',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Fuel_Type',
    timestamp: '2025-06-25 08:15:15.515831',
  },
  {
    type: 'default',
    message: '  - Fuel Type Valid Value Check: Ensure Energy_Fuel_Type contains only valid predefined values:',
    timestamp: '2025-06-25 08:15:15.531551',
  },
  {
    type: 'default',
    message: '  - Cross-Column Fuel Type Consistency Check: Energy_Fuel_Type should be consistent with Iocl_Fuel_Type:',
    timestamp: '2025-06-25 08:15:15.555441',
  },
  {
    type: 'default',
    message:
      "  - Unique Energy Record Check: Validate that Energy_Fuel_Type value isn't duplicated within the same Energy_record_id:",
    timestamp: '2025-06-25 08:15:15.569569',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Fuel Type Valid Value Check',
    timestamp: '2025-06-25 08:15:15.583420',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Fuel Type Valid Value Check',
    timestamp: '2025-06-25 08:15:15.597403',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Fuel Type Valid Value Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:15:21.895484',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:15:21.976167',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:15:21.989178',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule checks if the Energy_Fuel_Type column contains certain predefined values ('Fuel Oil', 'Natural Gas', 'Diesel') and filters them out. However, based on the sample values provided, i.e., ['Fuel Oil', 'Fuel Oil', 'Fuel Oil'], all these values are being excluded by the rule. This suggests that the rule is too strict because it filters out what appears to be legitimate values according to the provided sample data. Additionally, the description indicates the rule is supposed to ensure the column only contains valid predefined values, but the code does the opposite by filtering out these values, showcasing a logical inconsistency.",
    timestamp: '2025-06-25 08:15:36.159265',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:15:36.241390',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Fuel Type Valid Value Inclusion',
    timestamp: '2025-06-25 08:15:37.601962',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:15:50.086972',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Fuel Type Valid Value Inclusion',
    timestamp: '2025-06-25 08:15:52.189263',
  },
  {
    type: 'default',
    message:
      "    New code: valid_fuel_types = array(lit('fuel oil'), lit('natural gas'), lit('diesel'));\nlower_fuel_type_column = lower(trim(col('Energy_Fuel_Type')));\nresult_df = df.filter(array_contains(valid_fuel_types, lower_fuel_type_column))",
    timestamp: '2025-06-25 08:15:52.203950',
  },
  {
    type: 'default',
    message:
      "    New description: Ensure Energy_Fuel_Type contains valid yet potentially broad range of fuel types: 'Fuel Oil', 'Natural Gas', 'Diesel', and accommodate for common variations like case sensitivity",
    timestamp: '2025-06-25 08:15:52.216723',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Fuel Type Valid Value Inclusion',
    timestamp: '2025-06-25 08:15:52.230707',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:16:04.599510',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Fuel Type Valid Value Inclusion' - quality score below 80%",
    timestamp: '2025-06-25 08:16:04.733564',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:04.753068',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:04.769744',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 33.1%)',
    timestamp: '2025-06-25 08:16:15.983666',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Refined Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:17.147174',
  },
  {
    type: 'default',
    message:
      '    New code: comparison_logic = expr("(trim(lower(Energy_Fuel_Type)) != trim(lower(Iocl_Fuel_Type)))")\nresult_df = df.filter(comparison_logic)',
    timestamp: '2025-06-25 08:16:17.162364',
  },
  {
    type: 'default',
    message:
      '    New description: Energy_Fuel_Type should be broadly consistent with Iocl_Fuel_Type, accounting for common equivalent values',
    timestamp: '2025-06-25 08:16:17.176131',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Refined Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:17.189888',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 33.1%)',
    timestamp: '2025-06-25 08:16:25.796051',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Updated Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:28.293737',
  },
  {
    type: 'default',
    message:
      "    New code: comparison_logic = expr(\"trim(lower(Energy_Fuel_Type)) != trim(lower(Iocl_Fuel_Type)) AND NOT (lower(trim(Energy_Fuel_Type)) LIKE '%petrol%' AND lower(trim(Iocl_Fuel_Type)) LIKE '%gasoline%') AND NOT (lower(trim(Energy_Fuel_Type)) LIKE '%diesel%' AND lower(trim(Iocl_Fuel_Type)) LIKE '%gas oil%')\")\nresult_df = df.filter(comparison_logic)",
    timestamp: '2025-06-25 08:16:28.307874',
  },
  {
    type: 'default',
    message:
      '    New description: Energy_Fuel_Type should be broadly consistent with Iocl_Fuel_Type, accounting for common equivalent values and ignoring case and leading/trailing spaces',
    timestamp: '2025-06-25 08:16:28.320109',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Updated Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:16:28.335254',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 33.1%)',
    timestamp: '2025-06-25 08:16:38.028745',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Updated Cross-Column Fuel Type Consistency Check' - quality score below 80%",
    timestamp: '2025-06-25 08:16:38.107182',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Unique Energy Record Check',
    timestamp: '2025-06-25 08:16:38.119978',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Unique Energy Record Check',
    timestamp: '2025-06-25 08:16:38.132581',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.99%',
    timestamp: '2025-06-25 08:16:46.443622',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:16:46.576154',
  },
  {
    type: 'default',
    message:
      '    ⚠️ Rule failed common sense check: The rule checks for uniqueness of Energy_Fuel_Type values within the same Energy_record_id. However, based on the example data and column context provided, it seems that Energy_Fuel_Type is expected to have the same value repeated, indicating that duplication within a record might be intentional and valid. Also, the uniqueness percentage implies that values are highly repetitive, suggesting that the rule might not be appropriate for this dataset.',
    timestamp: '2025-06-25 08:17:00.429151',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:17:00.517086',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Refined Unique Energy Record Check',
    timestamp: '2025-06-25 08:17:02.126422',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Refined Unique Energy Record Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:17:10.111428',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:17:10.251633',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:17:10.275117',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:17:25.593899',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Refined Unique Energy Record Check',
    timestamp: '2025-06-25 08:17:25.677363',
  },
  {
    type: 'rule',
    message:
      'Check for unexpected variations in Energy_Fuel_Type values within the same Energy_record_id. Duplicate values are assumed valid, but a high diversity might indicate data issues.',
    timestamp: '2025-06-25 08:17:25.752896',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Value',
    timestamp: '2025-06-25 08:17:25.778487',
  },
  {
    type: 'code',
    message:
      "result_df = df.groupBy('Energy_record_id').agg(countDistinct('Energy_Fuel_Type').alias('distinct_count')).filter(col('distinct_count') > 1)",
    timestamp: '2025-06-25 08:17:25.765345',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Value',
    timestamp: '2025-06-25 08:18:09.814813',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Value',
    timestamp: '2025-06-25 08:18:13.705559',
  },
  {
    type: 'default',
    message: '  - Energy_Value_Is_Numeric: Validates that Energy_Value contains only numeric characters.:',
    timestamp: '2025-06-25 08:18:13.719905',
  },
  {
    type: 'default',
    message: '  - Energy_Value_NonNull: Checks that the Energy_Value column does not contain null values.:',
    timestamp: '2025-06-25 08:18:13.733549',
  },
  {
    type: 'default',
    message:
      '  - Energy_Value_Unit_Consistency: Ensures Energy_Value is consistent with its unit by checking specific Energy_Unit values that logically pair with typical numerical ranges, for example ensuring large numbers correspond to GJ.:',
    timestamp: '2025-06-25 08:18:13.749283',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Value_Is_Numeric',
    timestamp: '2025-06-25 08:18:13.763085',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Value_Is_Numeric',
    timestamp: '2025-06-25 08:18:13.775512',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 94.72%',
    timestamp: '2025-06-25 08:18:22.540200',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:18:22.624051',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 94.72% and passed common sense check',
    timestamp: '2025-06-25 08:18:36.375609',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Value_Is_Numeric',
    timestamp: '2025-06-25 08:18:36.457210',
  },
  {
    type: 'rule',
    message: 'Validates that Energy_Value contains only numeric characters.',
    timestamp: '2025-06-25 08:18:36.469729',
  },
  {
    type: 'code',
    message: "result_df = df.filter(~col('Energy_Value').rlike('^[0-9]+$'))",
    timestamp: '2025-06-25 08:18:36.482061',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Value_NonNull',
    timestamp: '2025-06-25 08:18:36.496701',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Value_NonNull',
    timestamp: '2025-06-25 08:18:36.509873',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 94.72%',
    timestamp: '2025-06-25 08:18:43.334572',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:18:43.464548',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 94.72% and passed common sense check',
    timestamp: '2025-06-25 08:18:57.637179',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Value_NonNull',
    timestamp: '2025-06-25 08:18:57.715431',
  },
  {
    type: 'rule',
    message: 'Checks that the Energy_Value column does not contain null values.',
    timestamp: '2025-06-25 08:18:57.727746',
  },
  {
    type: 'code',
    message: "result_df = df.filter(isnull(col('Energy_Value'))) ",
    timestamp: '2025-06-25 08:18:57.738960',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Value_Unit_Consistency',
    timestamp: '2025-06-25 08:18:57.751342',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Value_Unit_Consistency',
    timestamp: '2025-06-25 08:18:57.763885',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Energy_Value_Unit_Consistency. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:19:09.938014',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:19:10.018520',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:19:10.034067',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description indicates it intends to ensure consistency between Energy_Value and Energy_Unit. However, the logic in the code filters values where Energy_Unit is 'GJ' and Energy_Value is less than 1000, which would be inconsistent as GJ typically represents large energy values. The profile data shows Energy_Value example values that are significantly larger (2843651), further indicating the rule's condition is likely incorrect. Thus, the rule is too strict for this context and does not effectively identify inconsistent data.",
    timestamp: '2025-06-25 08:19:24.418276',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:19:24.498895',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Value_Unit_Consistency_Refined',
    timestamp: '2025-06-25 08:19:26.074698',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 15.85%)',
    timestamp: '2025-06-25 08:19:34.335087',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Value_Unit_Consistency_Optimized',
    timestamp: '2025-06-25 08:19:36.508416',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(((col('Energy_Unit') == 'GJ') & (col('Energy_Value').cast('double') >= 500)) | ((col('Energy_Unit') == 'MJ') & (col('Energy_Value').cast('double') < 5000)))",
    timestamp: '2025-06-25 08:19:36.522288',
  },
  {
    type: 'default',
    message:
      '    New description: Adjusts consistency check between Energy_Value and Energy_Unit by allowing a slightly wider range of numerical values for each unit.',
    timestamp: '2025-06-25 08:19:36.535294',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Value_Unit_Consistency_Optimized',
    timestamp: '2025-06-25 08:19:36.546867',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 15.85%)',
    timestamp: '2025-06-25 08:19:45.604555',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Energy_Value_Unit_Consistency_Optimized' - quality score below 80%",
    timestamp: '2025-06-25 08:19:45.763089',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Unit',
    timestamp: '2025-06-25 08:19:45.777851',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Unit',
    timestamp: '2025-06-25 08:20:28.468756',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Unit',
    timestamp: '2025-06-25 08:20:33.081069',
  },
  {
    type: 'default',
    message:
      "  - Energy_Unit_Fixed_Value_Validation: Validates that the Energy_Unit column contains only the fixed value 'GJ'.:",
    timestamp: '2025-06-25 08:20:33.103799',
  },
  {
    type: 'default',
    message:
      "  - Energy_Unit_Fuel_Type_Consistency: Checks consistency of the Energy_Unit with Energy_Fuel_Type and Iocl_Fuel_Type columns. Both related columns should have the same value if the Energy_Unit is 'GJ'.:",
    timestamp: '2025-06-25 08:20:33.117012',
  },
  {
    type: 'default',
    message:
      '  - Energy_Unit_Column_Length_Validation: Validates the length of the values in the Energy_Unit column to be exactly 2 characters.:',
    timestamp: '2025-06-25 08:20:33.130116',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Unit_Fixed_Value_Validation',
    timestamp: '2025-06-25 08:20:33.146001',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Unit_Fixed_Value_Validation',
    timestamp: '2025-06-25 08:20:33.159975',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 94.72%',
    timestamp: '2025-06-25 08:20:40.292946',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:20:40.380126',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description suggests that the validation should ensure Energy_Unit contains only the fixed value 'GJ', however, the actual rule implementation filters out these values, which is the opposite of validation and is not consistent with ensuring data quality. The column context indicates that the values are indeed all 'GJ', which matches the intended 'fixed value'. Therefore, the rule doesn't serve its intended purpose and results in a logical inconsistency.",
    timestamp: '2025-06-25 08:20:53.805738',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:20:53.887690',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Unit_Validation',
    timestamp: '2025-06-25 08:20:54.896985',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 94.72%',
    timestamp: '2025-06-25 08:21:02.057075',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:21:02.141438',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 94.72% and passed common sense check',
    timestamp: '2025-06-25 08:21:15.574377',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Unit_Validation',
    timestamp: '2025-06-25 08:21:15.656247',
  },
  {
    type: 'rule',
    message:
      "Validates that the Energy_Unit column contains only the allowed fixed value 'GJ'. Flag records where this condition is not met.",
    timestamp: '2025-06-25 08:21:15.669788',
  },
  {
    type: 'code',
    message: "result_df = df.filter(col('Energy_Unit') != 'GJ')",
    timestamp: '2025-06-25 08:21:15.686532',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Unit_Fuel_Type_Consistency',
    timestamp: '2025-06-25 08:21:15.700576',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Unit_Fuel_Type_Consistency',
    timestamp: '2025-06-25 08:21:15.716384',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 36.98%)',
    timestamp: '2025-06-25 08:21:23.522828',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Unit_Fuel_Type_Consistency_Refined',
    timestamp: '2025-06-25 08:21:25.344584',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((col('Energy_Unit') == 'GJ') & (col('Energy_Fuel_Type') != col('Iocl_Fuel_Type')) & (col('Energy_Fuel_Type') != 'GJ') & (col('Iocl_Fuel_Type') != 'GJ'))",
    timestamp: '2025-06-25 08:21:25.360046',
  },
  {
    type: 'default',
    message:
      "    New description: Checks consistency of Energy Unit with both Energy Fuel Type and Iocl Fuel Type columns. When Energy Unit is 'GJ', at least one of the related columns should match.",
    timestamp: '2025-06-25 08:21:25.373586',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Unit_Fuel_Type_Consistency_Refined',
    timestamp: '2025-06-25 08:21:25.387092',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 36.98%)',
    timestamp: '2025-06-25 08:21:33.060921',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Unit_Fuel_Type_Consistency_Refined_v2',
    timestamp: '2025-06-25 08:21:34.744058',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((col('Energy_Unit') == 'GJ') & (col('Energy_Fuel_Type') != col('Iocl_Fuel_Type')) & (col('Energy_Fuel_Type') != 'GJ') & (col('Iocl_Fuel_Type') != 'GJ'))",
    timestamp: '2025-06-25 08:21:34.760516',
  },
  {
    type: 'default',
    message:
      "    New description: Refined consistency check of Energy Unit with both Energy Fuel Type and Iocl Fuel Type columns. When Energy Unit is 'GJ', at least one of the related columns should match or be 'GJ'.",
    timestamp: '2025-06-25 08:21:34.773743',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Unit_Fuel_Type_Consistency_Refined_v2',
    timestamp: '2025-06-25 08:21:34.787537',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 36.98%)',
    timestamp: '2025-06-25 08:21:42.217044',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Energy_Unit_Fuel_Type_Consistency_Refined_v2' - quality score below 80%",
    timestamp: '2025-06-25 08:21:42.352621',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Unit_Column_Length_Validation',
    timestamp: '2025-06-25 08:21:42.373664',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Unit_Column_Length_Validation',
    timestamp: '2025-06-25 08:21:42.391953',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 94.72%',
    timestamp: '2025-06-25 08:21:49.767979',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:21:49.846940',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 94.72% and passed common sense check',
    timestamp: '2025-06-25 08:22:04.295452',
  },
  {
    type: 'rule',
    message: 'Validates the length of the values in the Energy_Unit column to be exactly 2 characters.',
    timestamp: '2025-06-25 08:22:04.392473',
  },
  {
    type: 'code',
    message: "result_df = df.filter(length(col('Energy_Unit')) != 2)",
    timestamp: '2025-06-25 08:22:04.405243',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Unit_Column_Length_Validation',
    timestamp: '2025-06-25 08:22:04.378599',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Month',
    timestamp: '2025-06-25 08:22:04.418806',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Month',
    timestamp: '2025-06-25 08:22:51.512878',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Month',
    timestamp: '2025-06-25 08:22:55.542046',
  },
  {
    type: 'default',
    message: "  - Month Format Validation: Validate that the 'Month' column follows the YYYY-MM format.:",
    timestamp: '2025-06-25 08:22:55.554683',
  },
  {
    type: 'default',
    message:
      "  - Cross-Column Date Consistency: The 'Month' column month should be consistent with the months derived from 'Safety_Date' and 'Water_Date'.:",
    timestamp: '2025-06-25 08:22:55.567504',
  },
  {
    type: 'default',
    message: "  - Duplicate Detection in Month: Ensure 'Month' column does not contain duplicate values.:",
    timestamp: '2025-06-25 08:22:55.579065',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Month Format Validation',
    timestamp: '2025-06-25 08:22:55.591770',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Month Format Validation',
    timestamp: '2025-06-25 08:22:55.603699',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Month Format Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:23:02.866018',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:23:02.947293',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:23:02.958888',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:23:17.610415',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Month Format Validation',
    timestamp: '2025-06-25 08:23:17.697847',
  },
  {
    type: 'rule',
    message: "Validate that the 'Month' column follows the YYYY-MM format.",
    timestamp: '2025-06-25 08:23:17.712969',
  },
  {
    type: 'code',
    message: "result_df = df.filter(~col('Month').rlike('^\\\\d{4}-\\\\d{2}$'))",
    timestamp: '2025-06-25 08:23:17.726854',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Cross-Column Date Consistency',
    timestamp: '2025-06-25 08:23:17.742702',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Cross-Column Date Consistency',
    timestamp: '2025-06-25 08:23:17.757558',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.09%)',
    timestamp: '2025-06-25 08:23:30.552538',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Cross-Column Date Consistency - Lenient',
    timestamp: '2025-06-25 08:23:32.233202',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(~(date_format(to_date(col('Safety_Date'), 'dd-MM-yyyy'), 'yyyy-MM') >= date_format(add_months(to_date(concat(col('Month'), '-01'), 'yyyy-MM-dd'), -1), 'yyyy-MM')) | ~(date_format(to_date(col('Water_Date'), 'dd-MM-yyyy'), 'yyyy-MM') >= date_format(add_months(to_date(concat(col('Month'), '-01'), 'yyyy-MM-dd'), -1), 'yyyy-MM')))",
    timestamp: '2025-06-25 08:23:32.268475',
  },
  {
    type: 'default',
    message:
      "    New description: The 'Month' column month should be generally consistent with the derived months from 'Safety_Date' and 'Water_Date'. Allow some margin for recent updates.",
    timestamp: '2025-06-25 08:23:32.281932',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Cross-Column Date Consistency - Lenient',
    timestamp: '2025-06-25 08:23:32.294868',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:23:35.393271',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Cross-Column Date Consistency - Lenient (Refined)',
    timestamp: '2025-06-25 08:23:37.217680',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((date_format(to_date(col('Safety_Date'), 'dd-MM-yyyy'), 'MM-yyyy') == date_format(to_date(concat(col('Month'), '-01'), 'yyyy-MM-dd'), 'MM-yyyy')) | (date_format(to_date(col('Water_Date'), 'dd-MM-yyyy'), 'MM-yyyy') == date_format(to_date(concat(col('Month'), '-01'), 'yyyy-MM-dd'), 'MM-yyyy')))",
    timestamp: '2025-06-25 08:23:37.235655',
  },
  {
    type: 'default',
    message:
      "    New description: The 'Month' column's month should be generally consistent with the derived months from 'Safety_Date' and 'Water_Date'. Allow a margin for recent updates within 1 month preceding.",
    timestamp: '2025-06-25 08:23:37.251585',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Cross-Column Date Consistency - Lenient (Refined)',
    timestamp: '2025-06-25 08:23:37.268577',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:23:40.527091',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Cross-Column Date Consistency - Lenient (Refined)' - quality score below 80%",
    timestamp: '2025-06-25 08:23:40.546973',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Duplicate Detection in Month',
    timestamp: '2025-06-25 08:23:40.564050',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Duplicate Detection in Month',
    timestamp: '2025-06-25 08:23:40.582109',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:23:50.187880',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:23:50.302139',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule logic does not make sense for the context provided. The 'Month' column is likely intended to categorize data by month periods, but the rule aims to ensure no duplicates, which would not be feasible because it is common and expected to have repeated months within datasets as they represent time periods. The rule does not address any actual data quality issues since the column might contain multiple entries for the same month (such as every transaction in a particular month). Therefore, it is unnecessarily strict and not aligned with typical use cases for such a column.",
    timestamp: '2025-06-25 08:24:05.133787',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:24:05.236126',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Valid Month Format Detection',
    timestamp: '2025-06-25 08:24:06.443471',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:24:15.297584',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Lenient Valid Month Format Detection',
    timestamp: '2025-06-25 08:24:16.670388',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(col('Month').isNotNull() & ~regexp_extract(trim(col('Month')), '^\\d{4}-(0[1-9]|1[0-2])$', 0).isNull())",
    timestamp: '2025-06-25 08:24:16.683943',
  },
  {
    type: 'default',
    message:
      "    New description: Ensure the 'Month' column contains valid month formats or handle missing and null values gracefully (e.g., 'YYYY-MM').",
    timestamp: '2025-06-25 08:24:16.745132',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Lenient Valid Month Format Detection',
    timestamp: '2025-06-25 08:24:16.758601',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:24:25.386429',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Lenient Valid Month Format Detection' - quality score below 80%",
    timestamp: '2025-06-25 08:24:25.511978',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Energy_Source',
    timestamp: '2025-06-25 08:24:25.527150',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Energy_Source',
    timestamp: '2025-06-25 08:25:10.916093',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Energy_Source',
    timestamp: '2025-06-25 08:25:15.039768',
  },
  {
    type: 'default',
    message:
      "  - Energy_Source_Business_Logic_Enum_Validation: Validates that Energy_Source only contains specific allowed values like 'EHS'.:",
    timestamp: '2025-06-25 08:25:15.052964',
  },
  {
    type: 'default',
    message:
      "  - Energy_Source_Consistency_With_Water_Source: Ensures that Energy_Source matches Water_Source when Water_Source is 'EHS'.:",
    timestamp: '2025-06-25 08:25:15.064853',
  },
  {
    type: 'default',
    message:
      '  - Energy_Source_Data_Integrity_Uniqueness: Checks that all values in Energy_Source are identical given the zero percent unique values.:',
    timestamp: '2025-06-25 08:25:15.094719',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Source_Business_Logic_Enum_Validation',
    timestamp: '2025-06-25 08:25:15.118775',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Source_Business_Logic_Enum_Validation',
    timestamp: '2025-06-25 08:25:15.107115',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 32.92%)',
    timestamp: '2025-06-25 08:25:23.590008',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Source_Business_Logic_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:25:24.840690',
  },
  {
    type: 'default',
    message: "    New code: result_df = df.filter(~col('Energy_Source').isin(['EHS', None, '']))",
    timestamp: '2025-06-25 08:25:24.854963',
  },
  {
    type: 'default',
    message:
      "    New description: Validates that Energy_Source contains allowed values like 'EHS', and also considers null values as valid.",
    timestamp: '2025-06-25 08:25:24.869304',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Source_Business_Logic_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:25:24.882669',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Energy_Source_Business_Logic_Enum_Validation_Refined. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:25:28.400820',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:25:28.415035',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:25:28.429230',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description states that null values are considered valid, but the code specifically filters these out with '~col('Energy_Source').isin(['EHS', None, ''])', which means rows with 'EHS', None, and '' are removed, contradicting the description. Additionally, given the current data sample where 100% of values are 'EHS', the rule would result in an empty DataFrame, indicating it's not suitable for this dataset.",
    timestamp: '2025-06-25 08:25:44.371904',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:25:44.450095',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Source_Business_Logic_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:25:45.611816',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:25:49.158214',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Energy_Source_Business_Logic_Enum_Validation_Refined' - quality score below 80%",
    timestamp: '2025-06-25 08:25:49.172284',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 08:25:49.187069',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 08:25:49.205092',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 78.27%',
    timestamp: '2025-06-25 08:25:56.955253',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:25:57.043293',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description states that the 'Energy_Source' should match the 'Water_Source' when 'Water_Source' is 'EHS'. However, the code filters instances where 'Water_Source' is 'EHS' and 'Energy_Source' is not 'EHS'. Given the sample data provided, where all 'Energy_Source' values are 'EHS', the rule does not seem to be catching any relevant data quality issues. Additionally, the description suggests a consistency check while the code's logic seems to be focusing on a mismatch case, indicating an inconsistency between description and implementation.",
    timestamp: '2025-06-25 08:26:12.915865',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:26:13.001231',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 08:26:14.600183',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 78.27%',
    timestamp: '2025-06-25 08:26:22.168378',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:26:22.299872',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 78.27% and passed common sense check',
    timestamp: '2025-06-25 08:26:36.726779',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 08:26:36.805263',
  },
  {
    type: 'rule',
    message:
      "Ensures that there is consistency between Energy_Source and Water_Source such that when Water_Source is 'EHS', Energy_Source must also be 'EHS'.",
    timestamp: '2025-06-25 08:26:36.817623',
  },
  {
    type: 'code',
    message: "result_df = df.filter((col('Water_Source') == 'EHS') & (col('Energy_Source') != 'EHS'))",
    timestamp: '2025-06-25 08:26:36.835656',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Energy_Source_Data_Integrity_Uniqueness',
    timestamp: '2025-06-25 08:26:36.848450',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Energy_Source_Data_Integrity_Uniqueness',
    timestamp: '2025-06-25 08:26:36.860095',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:26:39.956626',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Source_Data_Integrity_Uniqueness',
    timestamp: '2025-06-25 08:26:41.227713',
  },
  {
    type: 'default',
    message:
      "    New code: window_spec = Window.partitionBy().orderBy(lit(1)); distinct_count_df = df.withColumn('distinct_count', countDistinct('Energy_Source').over(window_spec)).filter(col('distinct_count') > 1); result_df = distinct_count_df",
    timestamp: '2025-06-25 08:26:41.242584',
  },
  {
    type: 'default',
    message: '    New description: Checks that all values in Energy_Source are consistent with low variability',
    timestamp: '2025-06-25 08:26:41.254853',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Energy_Source_Data_Integrity_Uniqueness',
    timestamp: '2025-06-25 08:26:41.267040',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:26:44.088577',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Energy_Source_Data_Integrity_Variability_Check',
    timestamp: '2025-06-25 08:26:45.578999',
  },
  {
    type: 'default',
    message:
      "    New code: energy_source_mode = df.groupBy('Energy_Source').count().orderBy(desc('count')).first()['Energy_Source']; result_df = df.filter(~(col('Energy_Source') == energy_source_mode))",
    timestamp: '2025-06-25 08:26:45.591988',
  },
  {
    type: 'default',
    message:
      '    New description: Ensures Energy_Source values are consistent with minimal variability by checking if they are mostly the same.',
    timestamp: '2025-06-25 08:26:45.609857',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Source_Data_Integrity_Variability_Check',
    timestamp: '2025-06-25 08:26:45.623125',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 32.92%)',
    timestamp: '2025-06-25 08:26:58.177899',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Energy_Source_Data_Integrity_Variability_Check' - quality score below 80%",
    timestamp: '2025-06-25 08:26:58.323219',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Gas',
    timestamp: '2025-06-25 08:26:58.341072',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Gas',
    timestamp: '2025-06-25 08:27:39.814978',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Gas',
    timestamp: '2025-06-25 08:27:42.802408',
  },
  {
    type: 'default',
    message: "  - Gas_Null_Check: Validates that 'Gas' column contains no null or empty values.:",
    timestamp: '2025-06-25 08:27:42.818716',
  },
  {
    type: 'default',
    message:
      "  - Gas_Valid_Value: Ensures 'Gas' column contains only specific allowed values related to business logic.:",
    timestamp: '2025-06-25 08:27:42.832531',
  },
  {
    type: 'default',
    message: "  - Gas_Scope_Consistency_Check: Validates 'Gas' matches expected 'Scope' category for consistency.:",
    timestamp: '2025-06-25 08:27:42.845537',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Gas_Null_Check',
    timestamp: '2025-06-25 08:27:42.860794',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Gas_Null_Check',
    timestamp: '2025-06-25 08:27:42.874976',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.94%',
    timestamp: '2025-06-25 08:27:50.237086',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:27:50.374612',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 99.94% and passed common sense check',
    timestamp: '2025-06-25 08:28:05.495116',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Gas_Null_Check',
    timestamp: '2025-06-25 08:28:05.580629',
  },
  {
    type: 'rule',
    message: "Validates that 'Gas' column contains no null or empty values.",
    timestamp: '2025-06-25 08:28:05.596026',
  },
  {
    type: 'code',
    message: "result_df = df.filter(isnull(col('Gas')) | (col('Gas') == ''))",
    timestamp: '2025-06-25 08:28:05.610067',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Gas_Valid_Value',
    timestamp: '2025-06-25 08:28:05.624533',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Gas_Valid_Value',
    timestamp: '2025-06-25 08:28:05.638118',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Gas_Valid_Value. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:28:15.126443',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:28:15.262185',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:28:15.285139',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:28:30.550082',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is intended to filter out 'N2O', 'CO2', and 'CH4' from the 'Gas' column. However, the example values from the data show that the only observed value is 'N2O', indicating that the rule might be too strict or misaligned with the actual data. The rule description suggests that only specific allowed values should be included, but the current code excludes important gases like 'N2O', 'CO2', and 'CH4'. This suggests a possible misunderstanding or misapplication of business logic.",
    timestamp: '2025-06-25 08:28:30.467863',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Gas_Allowed_Value',
    timestamp: '2025-06-25 08:28:31.970265',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.06%)',
    timestamp: '2025-06-25 08:28:41.332036',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Gas_Allowed_Value_Refined',
    timestamp: '2025-06-25 08:28:42.758256',
  },
  {
    type: 'default',
    message: "    New code: result_df = df.filter(upper(col('Gas')).isin(['N2O', 'CO2', 'CH4', 'C2H6', 'H2O']))",
    timestamp: '2025-06-25 08:28:42.772771',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures 'Gas' column contains only specific allowed values related to business logic. Includes additional related values.",
    timestamp: '2025-06-25 08:28:42.786151',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Gas_Allowed_Value_Refined',
    timestamp: '2025-06-25 08:28:42.801066',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0.06%)',
    timestamp: '2025-06-25 08:28:51.576696',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Gas_Allowed_Value_Refined' - quality score below 80%",
    timestamp: '2025-06-25 08:28:51.704956',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Gas_Scope_Consistency_Check',
    timestamp: '2025-06-25 08:28:51.723981',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Gas_Scope_Consistency_Check',
    timestamp: '2025-06-25 08:28:51.741062',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Gas_Scope_Consistency_Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:29:01.115509',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:29:01.285173',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:29:01.302069',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule requires that when 'Gas' is 'N2O', 'Scope' should not be 'Scope 1 – Combustion'. However, the data profile shows that the 'Gas' column contains 100% 'N2O' (based on the example values and 0.0% unique values percentage), implying that every entry would be subject to this rule. This raises the question of whether there are any valid 'Scope' types for 'N2O' or if this rule is categorically excluding all entries. Additionally, the rule description suggests checking for consistency, but the implementation excludes a specific condition without providing an alternative valid 'Scope'. This could be seen as overly strict if there are other valid scenarios not considered by the rule.",
    timestamp: '2025-06-25 08:29:26.567560',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:29:26.651590',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Gas_Scope_Consistency_Check_Refined',
    timestamp: '2025-06-25 08:29:28.152524',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Gas_Scope_Consistency_Check_Refined. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:29:35.499851',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:29:35.630168',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:29:35.649788',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description suggests checking alternative valid 'Scope' categories for records where 'Gas' is 'N2O'. However, the code only filters for 'N2O' entries with specific 'Scope' categories, without validating whether other categories might be valid. The rule seems to imply a refinement to validation logic, but the code merely performs a filter operation without any refinement or validation. Given that all 'Gas' values are 'N2O', and considering the low null percentage and unique values percentage, applying strict 'Scope' limitations may not reflect actual business requirements or data quality issues.",
    timestamp: '2025-06-25 08:29:51.740211',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:29:51.825210',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Gas_Scope_Consistency_Check_Improved',
    timestamp: '2025-06-25 08:29:53.017281',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Gas_Scope_Consistency_Check_Improved. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:30:00.678387',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:30:00.828938',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:30:00.846866',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is designed to validate entries with 'Gas' as 'N2O', checking they fall within specific 'Scope' categories. However, it seems overly restrictive given the sample data which only contains 'N2O'. With a null percentage of 0.06% and no unique values, the rule might not be useful as it doesn't account for other potential gases. The column description suggests no variety beyond 'N2O', questioning the flexibility of such a scope restriction. Additionally, there is no evidence that these scopes are the only valid ones for 'N2O'. The rule description claims enhanced validation, yet it appears to enforce a fixed scope rather than expand scope validity.",
    timestamp: '2025-06-25 08:30:15.618209',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:30:15.701476',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Scope',
    timestamp: '2025-06-25 08:30:15.714932',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Scope',
    timestamp: '2025-06-25 08:31:03.149991',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Scope',
    timestamp: '2025-06-25 08:31:06.889160',
  },
  {
    type: 'default',
    message: '  - Scope Null Check: Ensure Scope column does not have null values:',
    timestamp: '2025-06-25 08:31:06.903939',
  },
  {
    type: 'default',
    message: "  - Scope Business Logic Validation: Ensure 'Scope' matches predefined value 'Scope 1 – Combustion':",
    timestamp: '2025-06-25 08:31:06.917044',
  },
  {
    type: 'default',
    message:
      "  - Scope and Gas Consistency Check: Ensure 'Scope' is consistently associated with certain values in 'Gas', e.g., 'N2O':",
    timestamp: '2025-06-25 08:31:06.930570',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Scope Null Check',
    timestamp: '2025-06-25 08:31:06.944585',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Scope Null Check',
    timestamp: '2025-06-25 08:31:06.957518',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.94%',
    timestamp: '2025-06-25 08:31:13.852037',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:31:13.949071',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule logic filters rows with null values in the 'Scope' column, but the description implies that null values should not exist at all. Filtering for nulls just identifies them, which is not enforcing a constraint that prevents them. Given the null percentage is very low at 0.06%, the rule is more lenient than needed and not aligned with its description of ensuring no nulls. Additionally, there are no unique values beyond 'Scope 1 – Combustion', suggesting that any null handling should perhaps consider why these few nulls occur and address root causes rather than just filtering them.",
    timestamp: '2025-06-25 08:31:28.308922',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:31:28.384477',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Scope Null Check Refinement',
    timestamp: '2025-06-25 08:31:29.581710',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:31:36.532291',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Scope Null Replacement',
    timestamp: '2025-06-25 08:31:38.009088',
  },
  {
    type: 'default',
    message: "    New code: result_df = df.withColumn('Scope', coalesce(col('Scope'), lit('Unknown')))",
    timestamp: '2025-06-25 08:31:38.021893',
  },
  {
    type: 'default',
    message:
      "    New description: Replace null values in the Scope column with 'Unknown', allowing for more lenient quality check.",
    timestamp: '2025-06-25 08:31:38.035727',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Scope Null Replacement',
    timestamp: '2025-06-25 08:31:38.048227',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:31:44.467978',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Scope Null Replacement' - quality score below 80%",
    timestamp: '2025-06-25 08:31:44.602163',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Scope Business Logic Validation',
    timestamp: '2025-06-25 08:31:44.618811',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Scope Business Logic Validation',
    timestamp: '2025-06-25 08:31:44.632958',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Scope Business Logic Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:31:54.336700',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:31:54.470886',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:31:54.486123',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule described as 'Ensure Scope matches predefined value Scope 1 – Combustion' implies that values not matching this should be flagged or filtered out. However, the code provided is filtering out the rows where the 'Scope' matches 'Scope 1 – Combustion', which contradicts the description and would result in an empty DataFrame given the sample values which are all 'Scope 1 – Combustion'. Additionally, with a unique values percentage of 0.0%, it implies that this is the only value in the data, indicating that this rule is likely too strict and does not accommodate potential future valid values.",
    timestamp: '2025-06-25 08:32:10.985025',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:32:11.082395',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Scope Business Logic Validation',
    timestamp: '2025-06-25 08:32:12.062902',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.06%)',
    timestamp: '2025-06-25 08:32:19.424143',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Scope Business Logic Validation - Extended',
    timestamp: '2025-06-25 08:32:20.827558',
  },
  {
    type: 'default',
    message:
      "    New code: valid_scopes = ['Scope 1 – Combustion', 'Scope 2 – Purchased Electricity', 'Scope 3 – Indirect Emissions']\nresult_df = df.filter(col('Scope').isin(valid_scopes))",
    timestamp: '2025-06-25 08:32:20.843527',
  },
  {
    type: 'default',
    message:
      "    New description: Ensure 'Scope' matches a broader set of predefined values, including 'Scope 1 – Combustion'. Filter out records with values not matching these predefined valid values.",
    timestamp: '2025-06-25 08:32:20.857893',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Scope Business Logic Validation - Extended',
    timestamp: '2025-06-25 08:32:20.872251',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0.06%)',
    timestamp: '2025-06-25 08:32:28.969294',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Scope Business Logic Validation - Extended' - quality score below 80%",
    timestamp: '2025-06-25 08:32:29.057462',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:32:29.073729',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:32:29.089742',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 33.38%)',
    timestamp: '2025-06-25 08:32:38.510915',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:32:40.111679',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((col('Scope') == 'Scope 1 – Combustion') & (~col('Gas').isin(['N2O', 'CO2'])))",
    timestamp: '2025-06-25 08:32:40.129167',
  },
  {
    type: 'default',
    message:
      "    New description: Ensure 'Scope' is generally associated with specific values in 'Gas', such as 'N2O' for 'Scope 1 – Combustion', but allow some flexibility.",
    timestamp: '2025-06-25 08:32:40.143532',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:32:40.158409',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.69%',
    timestamp: '2025-06-25 08:32:47.456220',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:32:47.540857',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule indicates a logical inconsistency. The description mentions that 'Scope 1 – Combustion' should generally be associated with 'N2O' but allows flexibility. However, the code filters out records where 'Gas' is 'N2O' or 'CO2', contradicting the description's intention to associate 'Scope 1 – Combustion' with these gases. This also implies that if 'Scope' has only 'Scope 1 – Combustion' as a unique value, filtering 'N2O' and 'CO2' leaves the scope essentially empty, defeating the purpose.",
    timestamp: '2025-06-25 08:33:03.362404',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:33:03.457597',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:33:05.064859',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.69%',
    timestamp: '2025-06-25 08:33:13.679545',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:33:13.812991',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 66.69% and passed common sense check',
    timestamp: '2025-06-25 08:33:30.453067',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 08:33:30.531982',
  },
  {
    type: 'rule',
    message:
      "Ensure 'Scope' with value 'Scope 1 – Combustion' is generally associated with either 'N2O' or 'CO2' in 'Gas', reflecting typical emissions.",
    timestamp: '2025-06-25 08:33:30.589802',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Scope') == 'Scope 1 – Combustion') & (~col('Gas').isin(['N2O', 'CO2'])).alias('invalid_gas'))",
    timestamp: '2025-06-25 08:33:30.605497',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Measurement_Method',
    timestamp: '2025-06-25 08:33:30.621018',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Measurement_Method',
    timestamp: '2025-06-25 08:34:17.072643',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Measurement_Method',
    timestamp: '2025-06-25 08:34:20.264527',
  },
  {
    type: 'default',
    message:
      '  - Measurement_Method Uniformity: Validate that all values in Measurement_Method are identical as expected due to 0.0% uniqueness.:',
    timestamp: '2025-06-25 08:34:20.278882',
  },
  {
    type: 'default',
    message:
      '  - Measurement_Method Not Null: Ensure the Measurement_Method column has no null values due to its low null percentage.:',
    timestamp: '2025-06-25 08:34:20.292054',
  },
  {
    type: 'default',
    message:
      "  - Measurement_Method Valid Scope: Ensure that the Measurement_Method 'Emission Factor' is only present when Scope is 'Scope 1 – Combustion'.:",
    timestamp: '2025-06-25 08:34:20.308449',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Measurement_Method Uniformity',
    timestamp: '2025-06-25 08:34:20.323639',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Measurement_Method Uniformity',
    timestamp: '2025-06-25 08:34:20.339153',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:34:22.999403',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Measurement_Method Uniformity Refined',
    timestamp: '2025-06-25 08:34:24.557411',
  },
  {
    type: 'default',
    message:
      "    New code: from pyspark.sql import Window\nfrom pyspark.sql.functions import countDistinct\n\nw = Window.partitionBy()\nresult_df = df.withColumn('distinct_count', countDistinct('Measurement_Method').over(w)).filter(col('distinct_count') > 1).drop('distinct_count')",
    timestamp: '2025-06-25 08:34:24.571290',
  },
  {
    type: 'default',
    message:
      '    New description: Check if all values of Measurement_Method are identical by ensuring the distinct count is 1.',
    timestamp: '2025-06-25 08:34:24.583632',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Measurement_Method Uniformity Refined',
    timestamp: '2025-06-25 08:34:24.595946',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:34:27.405748',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Measurement_Method Uniformity Refined',
    timestamp: '2025-06-25 08:34:29.118761',
  },
  {
    type: 'default',
    message:
      "    New code: from pyspark.sql.functions import countDistinct\n\n# Calculate the distinct count of 'Measurement_Method' for the entire dataframe\ndistinct_count = df.select(countDistinct('Measurement_Method')).collect()[0][0]\n\n# Filter the dataframe only if more than one unique 'Measurement_Method' exists\nresult_df = df if distinct_count == 1 else df.limit(0)",
    timestamp: '2025-06-25 08:34:29.136965',
  },
  {
    type: 'default',
    message:
      '    New description: Ensure all values of Measurement_Method are uniform by checking if the distinct count is more than 1 at the dataset level.',
    timestamp: '2025-06-25 08:34:29.247596',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Measurement_Method Uniformity Refined',
    timestamp: '2025-06-25 08:34:29.261177',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Measurement_Method Uniformity Refined. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:34:36.669500',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:34:36.751273',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:34:36.765337',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is checking for uniformity in the 'Measurement_Method' column by ensuring all values are the same across the dataset. However, this may not be appropriate as different measurement methods could be valid depending on varying contexts or scenarios within the data. The column might need to support multiple values depending on business purposes, and enforcing strict uniformity could lead to discarding valid data unnecessarily. The example data provided already shows uniformity, but enforcing it as a rule might not be flexible and practical in real-world scenarios.",
    timestamp: '2025-06-25 08:34:51.953188',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:34:52.037662',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Measurement_Method Not Null',
    timestamp: '2025-06-25 08:34:52.050926',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Measurement_Method Not Null',
    timestamp: '2025-06-25 08:34:52.066769',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.94%',
    timestamp: '2025-06-25 08:35:09.553607',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:35:09.645284',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule does not make much sense given the context and data characteristics. The Measurement_Method column has only one unique value ('Emission Factor') and a very low null percentage (0.06%). It is very likely that the non-null values are the default expected value, and the impact of the existing null values may not be significant. Additionally, the rule description suggests a non-null constraint due to low null percentage, but the rule code only identifies rows with null or NaN values without addressing how to handle or rectify them. This makes the code misaligned with the description, which implies enforcing non-null values.",
    timestamp: '2025-06-25 08:35:25.148901',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:35:25.234820',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Measurement_Method Null Validation',
    timestamp: '2025-06-25 08:35:26.206410',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Measurement_Method Null Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:35:38.479749',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:35:38.615078',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:35:38.633594',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is intended to address null values by filtering, but the logic does not match the description. The code filters out rows where Measurement_Method is either null or NaN and not equal to 'Emission Factor', which contradicts the description. The description suggests filling nulls with 'Emission Factor', which is not implemented in the code. Since the column solely contains the value 'Emission Factor', setting a default value for null entries may be meaningful, but the logic should establish default values rather than filtering. Furthermore, the very low null percentage implies this situation is rare, making the rule somewhat unnecessary unless upstream data is expected to change.",
    timestamp: '2025-06-25 08:35:54.533261',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:35:54.612089',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Measurement_Method Default Value Assignment',
    timestamp: '2025-06-25 08:35:56.231068',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:36:03.181009',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Measurement_Method Default Value Assignment' - quality score below 80%",
    timestamp: '2025-06-25 08:36:03.312136',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Measurement_Method Valid Scope',
    timestamp: '2025-06-25 08:36:03.327697',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Measurement_Method Valid Scope',
    timestamp: '2025-06-25 08:36:03.343969',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Measurement_Method Valid Scope. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:36:10.978010',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:36:11.113164',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:36:11.127232',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:36:25.150530',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Measurement_Method Valid Scope',
    timestamp: '2025-06-25 08:36:25.237988',
  },
  {
    type: 'rule',
    message:
      "Ensure that the Measurement_Method 'Emission Factor' is only present when Scope is 'Scope 1 – Combustion'.",
    timestamp: '2025-06-25 08:36:25.251247',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Measurement_Method') == 'Emission Factor') & (col('Scope') != 'Scope 1 – Combustion'))",
    timestamp: '2025-06-25 08:36:25.264558',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Iocl_Fuel_Type',
    timestamp: '2025-06-25 08:36:25.280018',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Iocl_Fuel_Type',
    timestamp: '2025-06-25 08:37:21.404652',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Iocl_Fuel_Type',
    timestamp: '2025-06-25 08:37:24.633633',
  },
  {
    type: 'default',
    message:
      "  - Fuel Type Enum Validation: Ensures Iocl_Fuel_Type contains only predefined valid fuel types such as 'Fuel Oil'.:",
    timestamp: '2025-06-25 08:37:24.648612',
  },
  {
    type: 'default',
    message: '  - Null Value Check: Identifies records where Iocl_Fuel_Type is null to ensure completeness.:',
    timestamp: '2025-06-25 08:37:24.673676',
  },
  {
    type: 'default',
    message:
      '  - Cross-Column Fuel Type Consistency Check: Validates that Iocl_Fuel_Type matches Energy_Fuel_Type within the same record.:',
    timestamp: '2025-06-25 08:37:24.660686',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Fuel Type Enum Validation',
    timestamp: '2025-06-25 08:37:24.686616',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Fuel Type Enum Validation',
    timestamp: '2025-06-25 08:37:24.699809',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 39.19%)',
    timestamp: '2025-06-25 08:37:31.666801',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Fuel Type Enum Validation',
    timestamp: '2025-06-25 08:37:33.249906',
  },
  {
    type: 'default',
    message: "    New code: result_df = df.filter(~col('Iocl_Fuel_Type').isin(['Fuel Oil', 'Diesel', 'Petrol']))",
    timestamp: '2025-06-25 08:37:33.265028',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures Iocl_Fuel_Type contains only predefined valid fuel types, such as 'Fuel Oil', 'Diesel', and 'Petrol'.",
    timestamp: '2025-06-25 08:37:33.279771',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Fuel Type Enum Validation',
    timestamp: '2025-06-25 08:37:33.294407',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 39.19%)',
    timestamp: '2025-06-25 08:37:42.034237',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Fuel Type Enum Validation - Refined',
    timestamp: '2025-06-25 08:37:43.400568',
  },
  {
    type: 'default',
    message:
      "    New code: fuel_type_list = ['Fuel Oil', 'Diesel', 'Petrol']\nresult_df = df.filter(col('Iocl_Fuel_Type').isNotNull() & trim(col('Iocl_Fuel_Type')).isin(fuel_type_list))",
    timestamp: '2025-06-25 08:37:43.416362',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures Iocl_Fuel_Type contains predefined valid fuel types with enhanced accuracy. Valid types are 'Fuel Oil', 'Diesel', and 'Petrol'.",
    timestamp: '2025-06-25 08:37:43.429897',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Fuel Type Enum Validation - Refined',
    timestamp: '2025-06-25 08:37:43.443011',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 60.88%',
    timestamp: '2025-06-25 08:37:50.555884',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:37:50.639990',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 60.88% and passed common sense check',
    timestamp: '2025-06-25 08:38:04.365225',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Fuel Type Enum Validation - Refined',
    timestamp: '2025-06-25 08:38:04.444269',
  },
  {
    type: 'rule',
    message:
      "Ensures Iocl_Fuel_Type contains predefined valid fuel types with enhanced accuracy. Valid types are 'Fuel Oil', 'Diesel', and 'Petrol'.",
    timestamp: '2025-06-25 08:38:04.455937',
  },
  {
    type: 'code',
    message:
      "fuel_type_list = ['Fuel Oil', 'Diesel', 'Petrol']\nresult_df = df.filter(col('Iocl_Fuel_Type').isNotNull() & trim(col('Iocl_Fuel_Type')).isin(fuel_type_list))",
    timestamp: '2025-06-25 08:38:04.467851',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:38:04.480534',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Cross-Column Fuel Type Consistency Check',
    timestamp: '2025-06-25 08:38:04.493935',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 33.1%)',
    timestamp: '2025-06-25 08:38:13.366947',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Cross-Column Fuel Type Consistency Check v2',
    timestamp: '2025-06-25 08:38:14.874473',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(trim(lower(col('Iocl_Fuel_Type'))) != trim(lower(col('Energy_Fuel_Type'))))",
    timestamp: '2025-06-25 08:38:14.888837',
  },
  {
    type: 'default',
    message:
      '    New description: Validates that Iocl_Fuel_Type matches Energy_Fuel_Type within the same record, allowing for case and whitespace mismatches.',
    timestamp: '2025-06-25 08:38:14.902041',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Cross-Column Fuel Type Consistency Check v2',
    timestamp: '2025-06-25 08:38:14.915025',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 33.1%)',
    timestamp: '2025-06-25 08:38:24.055694',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Cross-Column Fuel Type Consistency Check v3',
    timestamp: '2025-06-25 08:38:26.483124',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(trim(lower(col('Iocl_Fuel_Type'))).alias('trimmed_iocl') != trim(lower(col('Energy_Fuel_Type'))).alias('trimmed_energy')).filter(~(col('trimmed_iocl').like('%gas%') & col('trimmed_energy').like('%gas%')))",
    timestamp: '2025-06-25 08:38:26.497546',
  },
  {
    type: 'default',
    message:
      '    New description: Validates that Iocl_Fuel_Type and Energy_Fuel_Type are consistent within the same record, considering minor variations like case and whitespace differences but allowing for common abbreviations.',
    timestamp: '2025-06-25 08:38:26.510608',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Cross-Column Fuel Type Consistency Check v3',
    timestamp: '2025-06-25 08:38:26.523798',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:38:29.560458',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Cross-Column Fuel Type Consistency Check v3' - quality score below 80%",
    timestamp: '2025-06-25 08:38:29.575990',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Null Value Check',
    timestamp: '2025-06-25 08:38:29.591275',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Null Value Check',
    timestamp: '2025-06-25 08:38:29.605580',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.94%',
    timestamp: '2025-06-25 08:38:39.047669',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:38:39.196716',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 99.94% and passed common sense check',
    timestamp: '2025-06-25 08:38:53.713392',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Null Value Check',
    timestamp: '2025-06-25 08:38:53.799031',
  },
  {
    type: 'rule',
    message: 'Identifies records where Iocl_Fuel_Type is null to ensure completeness.',
    timestamp: '2025-06-25 08:38:53.813187',
  },
  {
    type: 'code',
    message: "result_df = df.filter(isnull(col('Iocl_Fuel_Type')))",
    timestamp: '2025-06-25 08:38:53.828048',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Safety_Date',
    timestamp: '2025-06-25 08:38:53.840500',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Safety_Date',
    timestamp: '2025-06-25 08:39:42.529881',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Safety_Date',
    timestamp: '2025-06-25 08:39:46.713902',
  },
  {
    type: 'default',
    message: '  - Safety_Date_Format_Validation: Validates that Safety_Date is in DD-MM-YYYY format.:',
    timestamp: '2025-06-25 08:39:46.729651',
  },
  {
    type: 'default',
    message:
      '  - Safety_Date_Water_Date_Consistency: Ensures that Safety_Date is not after Water_Date when both dates are present.:',
    timestamp: '2025-06-25 08:39:46.744278',
  },
  {
    type: 'default',
    message: "  - Safety_Date_Month_Consistency: Ensures that the Safety_Date month matches the 'Month' column.:",
    timestamp: '2025-06-25 08:39:46.759037',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Safety_Date_Format_Validation',
    timestamp: '2025-06-25 08:39:46.773149',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Safety_Date_Format_Validation',
    timestamp: '2025-06-25 08:39:46.788409',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Safety_Date_Format_Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:39:56.139864',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:39:56.222921',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:39:56.237138',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:40:10.512069',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Safety_Date_Format_Validation',
    timestamp: '2025-06-25 08:40:10.594735',
  },
  {
    type: 'rule',
    message: 'Validates that Safety_Date is in DD-MM-YYYY format.',
    timestamp: '2025-06-25 08:40:10.608724',
  },
  {
    type: 'code',
    message: "result_df = df.filter(~col('Safety_Date').rlike('^\\d{2}-\\d{2}-\\d{4}$'))",
    timestamp: '2025-06-25 08:40:10.622800',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Safety_Date_Water_Date_Consistency',
    timestamp: '2025-06-25 08:40:10.636461',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Safety_Date_Water_Date_Consistency',
    timestamp: '2025-06-25 08:40:10.650507',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 72.0%',
    timestamp: '2025-06-25 08:40:25.692233',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:40:25.783105',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 72.0% and passed common sense check',
    timestamp: '2025-06-25 08:40:39.531069',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Safety_Date_Water_Date_Consistency',
    timestamp: '2025-06-25 08:40:39.606840',
  },
  {
    type: 'rule',
    message: 'Ensures that Safety_Date is not after Water_Date when both dates are present.',
    timestamp: '2025-06-25 08:40:39.618035',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((~isnull(col('Safety_Date'))) & (~isnull(col('Water_Date'))) & (to_date(col('Safety_Date'), 'dd-MM-yyyy') > to_date(col('Water_Date'), 'dd-MM-yyyy')))",
    timestamp: '2025-06-25 08:40:39.628665',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Safety_Date_Month_Consistency',
    timestamp: '2025-06-25 08:40:39.639826',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Safety_Date_Month_Consistency',
    timestamp: '2025-06-25 08:40:39.652362',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.15%)',
    timestamp: '2025-06-25 08:40:52.855363',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Safety_Date_Month_Consistency_Lenient',
    timestamp: '2025-06-25 08:40:54.030032',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(~(date_format(to_date(col('Safety_Date'), 'dd-MM-yyyy'), 'MM-yyyy') == split(col('Month'), '-')[0]))",
    timestamp: '2025-06-25 08:40:54.044527',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Safety_Date_Month_Consistency_Lenient',
    timestamp: '2025-06-25 08:40:54.071025',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures that the Safety_Date month approximately matches the 'Month' column, allowing minor format inconsistencies.",
    timestamp: '2025-06-25 08:40:54.057714',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.15%)',
    timestamp: '2025-06-25 08:41:06.482506',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Safety_Date_Month_Consistency_More_Lenient',
    timestamp: '2025-06-25 08:41:08.393578',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(~(date_format(to_date(col('Safety_Date'), 'dd-MM-yyyy'), 'MM') == split(col('Month'), '-')[0]))",
    timestamp: '2025-06-25 08:41:08.406874',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures that the Safety_Date month approximately matches the 'Month' column with a more lenient approach to account for format inconsistencies.",
    timestamp: '2025-06-25 08:41:08.418819',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Safety_Date_Month_Consistency_More_Lenient',
    timestamp: '2025-06-25 08:41:08.432838',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0.15%)',
    timestamp: '2025-06-25 08:41:19.178648',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Safety_Date_Month_Consistency_More_Lenient' - quality score below 80%",
    timestamp: '2025-06-25 08:41:19.258207',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Material_type',
    timestamp: '2025-06-25 08:41:19.269637',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Material_type',
    timestamp: '2025-06-25 08:42:01.433215',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Material_type',
    timestamp: '2025-06-25 08:42:05.113729',
  },
  {
    type: 'default',
    message:
      "  - Material_type Enum Validation: Ensures that Material_type only contains allowed values such as 'Crude input', 'Processed output'.:",
    timestamp: '2025-06-25 08:42:05.129829',
  },
  {
    type: 'default',
    message:
      "  - Material_Type and Energy_Facility Consistency Check: Checks for consistency between Material_type and Energy_Facility, ensuring that Crude input is used only in 'Gujarat Refinery'.:",
    timestamp: '2025-06-25 08:42:05.143430',
  },
  {
    type: 'default',
    message:
      "  - Material_type Duplicate Detection: Checks for duplicate entries in Material_type as all records have the value 'Crude input'.:",
    timestamp: '2025-06-25 08:42:05.155637',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Material_type Enum Validation',
    timestamp: '2025-06-25 08:42:05.169199',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Material_type Enum Validation',
    timestamp: '2025-06-25 08:42:05.181713',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.64%',
    timestamp: '2025-06-25 08:42:14.876204',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:42:14.957295',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule logic does not make sense because the current filter applied in the code actually removes rows that match the allowed values ('Crude input', 'Processed output'), which is counter to the description that aims to validate these are the only values present. Furthermore, considering that the unique values percentage is 0.0% and sample values only consist of 'Crude input', it suggests either the data is not fully captured, or it's highly unlikely that any 'Processed output' values exist. The rule doesn't account for potential future valid values, making it overly strict based on the current data example.",
    timestamp: '2025-06-25 08:42:35.412345',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:42:35.489765',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Material_type Enum Validation - Refined',
    timestamp: '2025-06-25 08:42:37.544377',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.64%',
    timestamp: '2025-06-25 08:42:47.267101',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:42:47.398731',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 66.64% and passed common sense check',
    timestamp: '2025-06-25 08:43:02.579866',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Material_type Enum Validation - Refined',
    timestamp: '2025-06-25 08:43:02.664581',
  },
  {
    type: 'rule',
    message:
      "Validates that Material_type contains only existing allowed values 'Crude input', 'Processed output', and reserves consideration for potential future valid values.",
    timestamp: '2025-06-25 08:43:02.678003',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter(~col('Material_type').isin(['Crude input', 'Processed output'])).withColumn('Flagged', lit(True))",
    timestamp: '2025-06-25 08:43:02.690438',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Material_Type and Energy_Facility Consistency Check',
    timestamp: '2025-06-25 08:43:02.702286',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Material_Type and Energy_Facility Consistency Check',
    timestamp: '2025-06-25 08:43:02.716004',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 96.75%',
    timestamp: '2025-06-25 08:43:12.277090',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:43:12.358521',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule checks for consistency between 'Material_type' and 'Energy_Facility', specifying that 'Crude input' material type should only be associated with 'Gujarat Refinery'. However, the data characteristics show that all 'Material_type' values are 'Crude input', with 0% uniqueness. This means the rule only applies if the 'Energy_Facility' values differ, which is not validated by the provided data. The rule seems too strict, potentially excluding valid associations with other facilities that might exist.",
    timestamp: '2025-06-25 08:43:26.700746',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:43:26.782263',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Material_Type and Energy_Facility Inclusive Check',
    timestamp: '2025-06-25 08:43:28.281004',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 96.75%',
    timestamp: '2025-06-25 08:43:35.944571',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:43:36.068537',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule checks for association between 'Material_type' being 'Crude input' and permissible 'Energy_Facility'. However, based on the column context, the 'Material_type' column only contains the value 'Crude input'. Therefore, the rule is applied on data that doesn't seem to require such validation due to lack of variability. Additionally, targeting 'Material_type' doesn't align with the rule objective, which is actually about consistency with 'Energy_Facility'. Also, the rule limits allowed facilities to only three specified ones, which seems overly strict given it aims to improve inclusivity.",
    timestamp: '2025-06-25 08:43:50.551236',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:43:50.634050',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Energy_Facility Apache Check',
    timestamp: '2025-06-25 08:43:52.639996',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 95.18%',
    timestamp: '2025-06-25 08:44:00.522967',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:44:00.647325',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is intended to check if 'Energy_Facility' belongs to a specific set of refineries when 'Material_type' is 'Crude input'. However, the code provided is filtering out rows where 'Energy_Facility' is not in the allowed list, which contradicts the description that aims to align with an inclusivity objective. This indicates a logical inconsistency between the rule description and code implementation.",
    timestamp: '2025-06-25 08:44:15.636607',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:44:15.716232',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Material_type Duplicate Detection',
    timestamp: '2025-06-25 08:44:15.728482',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Material_type Duplicate Detection',
    timestamp: '2025-06-25 08:44:15.740540',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:44:18.977185',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Material_type Duplicate Detection',
    timestamp: '2025-06-25 08:44:20.037013',
  },
  {
    type: 'default',
    message: "    New code: result_df = df.filter(trim(lower(col('Material_type'))) != 'crude input')",
    timestamp: '2025-06-25 08:44:20.050304',
  },
  {
    type: 'default',
    message: "    New description: Checks that all entries in Material_type are 'Crude input'.",
    timestamp: '2025-06-25 08:44:20.061453',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Material_type Duplicate Detection',
    timestamp: '2025-06-25 08:44:20.073435',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.64%',
    timestamp: '2025-06-25 08:44:27.375448',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:44:27.561096',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is labeled as 'Material_type Duplicate Detection', but the code checks for anything that isn't 'Crude input'. This suggests that the rule is intended to validate that all values are 'Crude input'. Given the example data where all values are indeed 'Crude input', the rule is not performing duplicate detection but rather value consistency checking. Additionally, the expectation that all records have the same 'Material_type' value without any legitimate variability seems too strict and might not align with a real-world scenario where 'Material_type' could potentially have more than one valid entry. Hence, labeling this as duplicate detection is misleading.",
    timestamp: '2025-06-25 08:44:41.952566',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:44:42.031250',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Material_type Validity Check',
    timestamp: '2025-06-25 08:44:43.065472',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 66.64%',
    timestamp: '2025-06-25 08:44:51.283556',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:44:51.417527',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule purportedly aims to ensure that 'Material_type' contains valid entries with at least 'Crude input'. However, the code filters out rows with 'Crude input', which contradicts the rule description and logic. Given the sample data only includes 'Crude input', applying this filter would result in an empty DataFrame, and thus doesn't make sense for ensuring valid entries.",
    timestamp: '2025-06-25 08:45:05.340712',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed common sense validation and no iterations left',
    timestamp: '2025-06-25 08:45:05.424099',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Waste_Type',
    timestamp: '2025-06-25 08:45:05.437647',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Waste_Type',
    timestamp: '2025-06-25 08:45:51.668167',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Waste_Type',
    timestamp: '2025-06-25 08:45:54.898730',
  },
  {
    type: 'default',
    message:
      "  - Waste_Type_Enum_Validation: Ensure Waste_Type contains only predefined values ['Non-Hazardous', 'Hazardous']:",
    timestamp: '2025-06-25 08:45:54.914869',
  },
  {
    type: 'default',
    message: '  - Waste_Type_Length_Validation: Check that Waste_Type length does not exceed 20 characters:',
    timestamp: '2025-06-25 08:45:54.927888',
  },
  {
    type: 'default',
    message:
      "  - Cross_Column_Consistency_Waste_Type_Disposal_Method: Ensure Non-Hazardous Waste_Type must have 'Recycler Sale' as Waste_Disposal_Method:",
    timestamp: '2025-06-25 08:45:54.941745',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Type_Enum_Validation',
    timestamp: '2025-06-25 08:45:54.954975',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Type_Enum_Validation',
    timestamp: '2025-06-25 08:45:54.968660',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 50.0%)',
    timestamp: '2025-06-25 08:46:03.129819',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Waste_Type_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:46:04.454283',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(~trim(lower(col('Waste_Type'))).isin(['non-hazardous', 'hazardous']))",
    timestamp: '2025-06-25 08:46:04.468934',
  },
  {
    type: 'default',
    message:
      "    New description: Allow for case insensitivity and trimming whitespaces in Waste_Type when compared to predefined values ['Non-Hazardous', 'Hazardous']",
    timestamp: '2025-06-25 08:46:04.483021',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Type_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:46:04.498752',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 50.0%)',
    timestamp: '2025-06-25 08:46:12.843695',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Waste_Type_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:46:14.689407',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((col('Waste_Type').isNotNull()) & (~trim(lower(col('Waste_Type'))).isin(['non-hazardous', 'hazardous'])))",
    timestamp: '2025-06-25 08:46:14.704443',
  },
  {
    type: 'default',
    message:
      "    New description: Validate Waste_Type with case insensitivity, trimming whitespaces, and allowing missing values to pass when compared to predefined values ['Non-Hazardous', 'Hazardous']",
    timestamp: '2025-06-25 08:46:14.718008',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Type_Enum_Validation_Refined',
    timestamp: '2025-06-25 08:46:14.730914',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 50.0%)',
    timestamp: '2025-06-25 08:46:22.489085',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Waste_Type_Enum_Validation_Refined' - quality score below 80%",
    timestamp: '2025-06-25 08:46:22.571004',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Type_Length_Validation',
    timestamp: '2025-06-25 08:46:22.583489',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Type_Length_Validation',
    timestamp: '2025-06-25 08:46:22.596028',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Waste_Type_Length_Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:46:29.921569',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:46:30.005198',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:46:30.018552',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule checks if the length of 'Waste_Type' exceeds 20 characters. However, the example values provided ('Non‑Hazardous') are well below this length and cover most samples. Additionally, the 'Waste_Type' column has no unique values, implying consistency in terms used and suggests that lengthy names are unlikely. Therefore, the rule's strictness appears unnecessary for the data's characteristics, possibly missing the intention to cap entries which are unrealistic or erroneous.",
    timestamp: '2025-06-25 08:46:44.773944',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:46:44.858639',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Type_Length_Limit_Validation',
    timestamp: '2025-06-25 08:46:45.793474',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Type_Length_Limit_Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:46:55.448810',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:46:55.555533',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:46:55.569025',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule's description suggests allowing up to 50 characters, but the code actually flags entries longer than 50 characters as violations, which is the opposite of the intended purpose. Given the example values and the null and unique percentages, the 'Waste_Type' column seems to have very consistent and short values, like 'Non-Hazardous'. This makes the rule unnecessarily strict based on the available data. Additionally, if all the example values are much shorter than 50 characters, implementing a maximum length rule for 50 characters might not provide much value. The rule doesn't match what the description implies and is unlikely to capture any real data quality issues given the current dataset.",
    timestamp: '2025-06-25 08:47:11.199434',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:47:11.281106',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Type_Length_Validation',
    timestamp: '2025-06-25 08:47:12.242545',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0.0%)',
    timestamp: '2025-06-25 08:47:20.826479',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Waste_Type_Length_Validation' - quality score below 80%",
    timestamp: '2025-06-25 08:47:20.907923',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Cross_Column_Consistency_Waste_Type_Disposal_Method',
    timestamp: '2025-06-25 08:47:20.921555',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Cross_Column_Consistency_Waste_Type_Disposal_Method',
    timestamp: '2025-06-25 08:47:20.936239',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Cross_Column_Consistency_Waste_Type_Disposal_Method. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:47:28.604156',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:47:28.742046',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:47:28.760217',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: Evaluating the rule suggests it is overly strict and may not encompass all valid disposal methods for Non-Hazardous waste types. The rule mandates that a Non-Hazardous Waste_Type must exclusively use 'Recycler Sale' as the Waste_Disposal_Method, which disregards other potentially valid methods such as 'Landfill', 'Composting', or 'Recycling' depending on the context or industry standards. Additionally, the rule description matches the code logic, but fails to consider the broader set of disposal methods that may be appropriate.",
    timestamp: '2025-06-25 08:47:43.920489',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:47:43.999073',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Cross_Column_Consistency_NonHazardous_Waste_Disposal',
    timestamp: '2025-06-25 08:47:45.766484',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:47:55.085031',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:47:55.100033',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Cross_Column_Consistency_NonHazardous_Waste_Disposal. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:47:54.949465',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:48:10.728348',
  },
  {
    type: 'rule',
    message:
      "Ensure Non-Hazardous Waste_Type has appropriate Waste_Disposal_Method. Valid methods include 'Recycler Sale', 'Landfill', 'Composting', or 'Recycling'.",
    timestamp: '2025-06-25 08:48:10.819859',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Cross_Column_Consistency_NonHazardous_Waste_Disposal',
    timestamp: '2025-06-25 08:48:10.807479',
  },
  {
    type: 'code',
    message:
      "valid_methods = ['Recycler Sale', 'Landfill', 'Composting', 'Recycling']\nresult_df = df.filter((col('Waste_Type') == 'Non-Hazardous') & (~col('Waste_Disposal_Method').isin(valid_methods)))",
    timestamp: '2025-06-25 08:48:10.830846',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Waste_Category',
    timestamp: '2025-06-25 08:48:10.843037',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Waste_Category',
    timestamp: '2025-06-25 08:48:57.355462',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Waste_Category',
    timestamp: '2025-06-25 08:49:00.429276',
  },
  {
    type: 'default',
    message: '  - Waste_Category_Enum_Validation: Validates that Waste_Category contains only allowed values.:',
    timestamp: '2025-06-25 08:49:00.445477',
  },
  {
    type: 'default',
    message:
      "  - Waste_Category_Disposal_Method_Consistency: Checks consistency between Waste_Category 'Metal Scrap' and Waste_Disposal_Method 'Recycler Sale'.:",
    timestamp: '2025-06-25 08:49:00.458398',
  },
  {
    type: 'default',
    message:
      "  - Waste_Category_Waste_Type_Consistency: Ensures 'Metal Scrap' in Waste_Category matches Waste_Type 'Non‑Hazardous'.:",
    timestamp: '2025-06-25 08:49:00.473145',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Category_Enum_Validation',
    timestamp: '2025-06-25 08:49:00.486107',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Category_Enum_Validation',
    timestamp: '2025-06-25 08:49:00.502566',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 50.0%)',
    timestamp: '2025-06-25 08:49:12.672558',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Waste_Category_Enum_Validation_Improved',
    timestamp: '2025-06-25 08:49:13.737499',
  },
  {
    type: 'default',
    message:
      "    New code: allowed_values = ['Metal Scrap', 'Plastic Waste', 'Electronic Waste']; result_df = df.filter(col('Waste_Category').isin(allowed_values))",
    timestamp: '2025-06-25 08:49:13.752390',
  },
  {
    type: 'default',
    message:
      '    New description: Validates that Waste_Category contains a broader set of allowed values while excluding the common invalid entries.',
    timestamp: '2025-06-25 08:49:13.764151',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Category_Enum_Validation_Improved',
    timestamp: '2025-06-25 08:49:13.776181',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 50.0%)',
    timestamp: '2025-06-25 08:49:22.350032',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Waste_Category_Enum_Validation_Enhanced',
    timestamp: '2025-06-25 08:49:23.907583',
  },
  {
    type: 'default',
    message:
      "    New code: allowed_values = ['Metal Scrap', 'Plastic Waste', 'Electronic Waste', 'Glass Waste', 'Organic Waste', 'Paper Waste']; result_df = df.filter(col('Waste_Category').isin(allowed_values))",
    timestamp: '2025-06-25 08:49:23.922005',
  },
  {
    type: 'default',
    message:
      '    New description: Validates that Waste_Category contains a broader set of allowed values while excluding common invalid entries. Increased range of acceptable values.',
    timestamp: '2025-06-25 08:49:23.934186',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Category_Enum_Validation_Enhanced',
    timestamp: '2025-06-25 08:49:23.946203',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 50.0%)',
    timestamp: '2025-06-25 08:49:40.192268',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Waste_Category_Enum_Validation_Enhanced' - quality score below 80%",
    timestamp: '2025-06-25 08:49:40.267944',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 08:49:40.281216',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 08:49:40.295990',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Category_Disposal_Method_Consistency. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:49:47.104208',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:49:47.190585',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:49:47.204486',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is too strict because it mandates that all instances of 'Metal Scrap' in the Waste_Category column must have a corresponding Waste_Disposal_Method of 'Recycler Sale'. This doesn't account for other possible disposal methods for metal scrap that might be legitimate, such as 'Donation', 'Recycling Facility Drop-off', or 'Specialized Metal Recycler'. Given that the sample values provided are all 'Metal Scrap', this rule unnecessarily limits the flexibility and potential validity of the dataset. Furthermore, the rule description claims to check 'consistency', yet the code is enforcing a strict one-to-one mapping.",
    timestamp: '2025-06-25 08:50:00.954803',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:50:01.043598',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Refined_Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 08:50:02.774108',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Refined_Waste_Category_Disposal_Method_Consistency. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:50:11.245437',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:50:11.326899',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:50:11.342224',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:50:26.412748',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Refined_Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 08:50:26.502401',
  },
  {
    type: 'rule',
    message:
      "Checks if Waste_Category 'Metal Scrap' is handled with appropriate disposal methods, including 'Recycler Sale', 'Donation', 'Recycling Facility Drop-off', or 'Specialized Metal Recycler'.",
    timestamp: '2025-06-25 08:50:26.516895',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Waste_Category') == 'Metal Scrap') & ~col('Waste_Disposal_Method').isin(['Recycler Sale', 'Donation', 'Recycling Facility Drop-off', 'Specialized Metal Recycler']))",
    timestamp: '2025-06-25 08:50:26.530961',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Category_Waste_Type_Consistency',
    timestamp: '2025-06-25 08:50:26.546423',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Category_Waste_Type_Consistency',
    timestamp: '2025-06-25 08:50:26.560348',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Category_Waste_Type_Consistency. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:50:35.548270',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:50:35.684212',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:50:35.704776',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule description aims to ensure the consistency between 'Metal Scrap' in Waste_Category and 'Non‑Hazardous' in Waste_Type. However, the provided code actually filters for cases where this consistency is violated, i.e., when Waste_Type is not 'Non‑Hazardous', contrary to the description. Furthermore, the sample data only shows 'Metal Scrap' in Waste_Category, and there's no indication of any other Waste_Type or any cases where Waste_Type is other than 'Non‑Hazardous'. Thus, the rule might not be applicable, as there's no variability in Waste_Category, and likely none in Waste_Type either.",
    timestamp: '2025-06-25 08:50:53.636030',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:50:53.721915',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Category_Waste_Type_Consistency_Check',
    timestamp: '2025-06-25 08:50:55.458468',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 50.0%)',
    timestamp: '2025-06-25 08:51:11.017895',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Waste_Category_Waste_Type_Minor_Adjustment_Check',
    timestamp: '2025-06-25 08:51:12.510782',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((col('Waste_Category') == 'Metal Scrap') & (lower(trim(col('Waste_Type'))) != 'non-hazardous'))",
    timestamp: '2025-06-25 08:51:12.524509',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Category_Waste_Type_Minor_Adjustment_Check',
    timestamp: '2025-06-25 08:51:12.549443',
  },
  {
    type: 'default',
    message:
      "    New description: Ensures records with 'Metal Scrap' in Waste_Category mostly have Waste_Type as 'Non‑Hazardous', allowing for a grace margin.",
    timestamp: '2025-06-25 08:51:12.536829',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 50.0%)',
    timestamp: '2025-06-25 08:51:20.569230',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Waste_Category_Waste_Type_Minor_Adjustment_Check' - quality score below 80%",
    timestamp: '2025-06-25 08:51:20.653049',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Water_Source',
    timestamp: '2025-06-25 08:51:20.667337',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Water_Source',
    timestamp: '2025-06-25 08:52:05.481101',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Water_Source',
    timestamp: '2025-06-25 08:52:09.350945',
  },
  {
    type: 'default',
    message:
      '  - Water_Source_Not_Null_Check: Ensures that Water_Source column does not have null or empty string values.:',
    timestamp: '2025-06-25 08:52:09.364418',
  },
  {
    type: 'default',
    message:
      '  - Water_Source_Enum_Validation: Validates that Water_Source values are within the expected set of enum values.:',
    timestamp: '2025-06-25 08:52:09.376649',
  },
  {
    type: 'default',
    message:
      '  - Water_Source_Consistency_With_Energy_Source: Checks for consistency between Water_Source and Energy_Source, as they should not have conflicting values for a given record.:',
    timestamp: '2025-06-25 08:52:09.394568',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Source_Not_Null_Check',
    timestamp: '2025-06-25 08:52:09.487745',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Source_Not_Null_Check',
    timestamp: '2025-06-25 08:52:09.501355',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.91%',
    timestamp: '2025-06-25 08:52:16.301595',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:52:16.425647',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 99.91% and passed common sense check',
    timestamp: '2025-06-25 08:52:31.826688',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Water_Source_Not_Null_Check',
    timestamp: '2025-06-25 08:52:31.910022',
  },
  {
    type: 'rule',
    message: 'Ensures that Water_Source column does not have null or empty string values.',
    timestamp: '2025-06-25 08:52:31.923593',
  },
  {
    type: 'code',
    message: "result_df = df.filter(isnull(col('Water_Source')) | (col('Water_Source') == ''))",
    timestamp: '2025-06-25 08:52:31.935734',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Source_Enum_Validation',
    timestamp: '2025-06-25 08:52:31.947852',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Source_Enum_Validation',
    timestamp: '2025-06-25 08:52:31.985095',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 84.15%',
    timestamp: '2025-06-25 08:52:40.617039',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:52:40.750417',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 84.15% and passed common sense check',
    timestamp: '2025-06-25 08:52:55.295418',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Water_Source_Enum_Validation',
    timestamp: '2025-06-25 08:52:55.375761',
  },
  {
    type: 'rule',
    message: 'Validates that Water_Source values are within the expected set of enum values.',
    timestamp: '2025-06-25 08:52:55.389130',
  },
  {
    type: 'code',
    message:
      "valid_sources = ['Historian', 'EHS', 'Manual Logbook', 'LIMS']\nresult_df = df.filter(~col('Water_Source').isin(valid_sources))",
    timestamp: '2025-06-25 08:52:55.405131',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Source_Consistency_With_Energy_Source',
    timestamp: '2025-06-25 08:52:55.419955',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Source_Consistency_With_Energy_Source',
    timestamp: '2025-06-25 08:52:55.432614',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 16.67%)',
    timestamp: '2025-06-25 08:53:03.372694',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Water_Source_Consistency_With_Energy_Source_Refined',
    timestamp: '2025-06-25 08:53:05.146959',
  },
  {
    type: 'default',
    message:
      "    New code: accepted_combinations = [('Solar', 'Rainwater'), ('Wind', 'Groundwater')] result_df = df.filter((col('Water_Source') != col('Energy_Source')) & (~(struct(col('Water_Source'), col('Energy_Source')).isin(accepted_combinations))))",
    timestamp: '2025-06-25 08:53:05.162172',
  },
  {
    type: 'default',
    message:
      '    New description: Checks for consistency between Water_Source and Energy_Source, allowing certain acceptable combinations.',
    timestamp: '2025-06-25 08:53:05.175955',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Water_Source_Consistency_With_Energy_Source_Refined',
    timestamp: '2025-06-25 08:53:05.189176',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0%)',
    timestamp: '2025-06-25 08:53:08.350530',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Water_Source_Consistency_With_Energy_Source_Improved',
    timestamp: '2025-06-25 08:53:10.439301',
  },
  {
    type: 'default',
    message:
      "    New code: from pyspark.sql.functions import col, struct, isnull\n\naccepted_combinations = [('Solar', 'Rainwater'), ('Wind', 'Groundwater')]\n\nresult_df = df.filter(\n    (col('Water_Source') != col('Energy_Source')) &\n    (~struct(col('Water_Source'), col('Energy_Source')).isin(accepted_combinations)) &\n    ~(isnull(col('Water_Source')) | isnull(col('Energy_Source')))\n)",
    timestamp: '2025-06-25 08:53:10.454829',
  },
  {
    type: 'default',
    message:
      '    New description: Checks for consistency between Water_Source and Energy_Source, allowing certain acceptable combinations and handling cases where either source is null.',
    timestamp: '2025-06-25 08:53:10.466777',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Water_Source_Consistency_With_Energy_Source_Improved',
    timestamp: '2025-06-25 08:53:10.478894',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0%)',
    timestamp: '2025-06-25 08:53:13.650839',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Water_Source_Consistency_With_Energy_Source_Improved' - quality score below 80%",
    timestamp: '2025-06-25 08:53:13.668410',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Water_Date',
    timestamp: '2025-06-25 08:53:13.684174',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Water_Date',
    timestamp: '2025-06-25 08:53:57.975616',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Water_Date',
    timestamp: '2025-06-25 08:54:01.224448',
  },
  {
    type: 'default',
    message: '  - Water_Date_Format_Validation: Validate that Water_Date is in the format DD-MM-YYYY.:',
    timestamp: '2025-06-25 08:54:01.239919',
  },
  {
    type: 'default',
    message:
      '  - Water_Date_Matches_Safety_Date: Ensure Water_Date matches Safety_Date if both are not null; expect these dates to be consistent.:',
    timestamp: '2025-06-25 08:54:01.252912',
  },
  {
    type: 'default',
    message:
      '  - Water_Date_In_Month: Check that the Water_Date falls within the corresponding Month (same month and year).:',
    timestamp: '2025-06-25 08:54:01.266691',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Date_Format_Validation',
    timestamp: '2025-06-25 08:54:01.281682',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Date_Format_Validation',
    timestamp: '2025-06-25 08:54:01.294857',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Water_Date_Format_Validation. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:54:08.796262',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:54:08.880464',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:54:08.894148',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:54:23.268495',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Water_Date_Format_Validation',
    timestamp: '2025-06-25 08:54:23.349231',
  },
  {
    type: 'rule',
    message: 'Validate that Water_Date is in the format DD-MM-YYYY.',
    timestamp: '2025-06-25 08:54:23.363052',
  },
  {
    type: 'code',
    message: "result_df = df.filter(~col('Water_Date').rlike('^\\\\d{2}-\\\\d{2}-\\\\d{4}$'))",
    timestamp: '2025-06-25 08:54:23.376021',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:54:23.388551',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:54:23.401154',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 28.81%)',
    timestamp: '2025-06-25 08:54:31.766249',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:54:33.320415',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter((~(col('Water_Date').isNull() | col('Safety_Date').isNull())) & (datediff(col('Water_Date'), col('Safety_Date')) > 3))",
    timestamp: '2025-06-25 08:54:33.333699',
  },
  {
    type: 'default',
    message:
      '    New description: Ensure Water_Date matches Safety_Date if both are not null, but allow for discrepancies of up to 3 days.',
    timestamp: '2025-06-25 08:54:33.345778',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:54:33.358488',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Updated_Water_Date_Matches_Safety_Date. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:54:42.320904',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:54:42.448297',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:54:42.507114',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The data type of 'Water_Date' is string, which may not work correctly with the `datediff` function that expects date type columns. This might lead to incorrect comparisons. Additionally, the rule as implemented doesn't explicitly convert these string dates into a date format before applying the `datediff` function. Moreover, the rule description specifies ensuring that the dates match or have a discrepancy of up to 3 days, but the logic inverts this intention by filtering when the discrepancy is greater than 3 days. This appears to be inconsistent with the description. The rule seems to be checking an inter-column relationship, but given the lack of unique values in 'Water_Date', it may not detect meaningful discrepancies, making this rule less useful for identifying real quality issues.",
    timestamp: '2025-06-25 08:54:57.243337',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:54:57.324703',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Refined_Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:54:58.841211',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Refined_Updated_Water_Date_Matches_Safety_Date. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:55:15.251077',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:55:15.387134',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:55:15.402860',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:55:29.701053',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Refined_Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 08:55:29.786602',
  },
  {
    type: 'rule',
    message:
      'Ensure Water_Date matches Safety_Date if both are not null, allowing for a discrepancy of no more than 3 days. Convert string date columns to date format before applying the comparison.',
    timestamp: '2025-06-25 08:55:29.799340',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((~(col('Water_Date').isNull() | col('Safety_Date').isNull())) & (abs(datediff(to_date(col('Water_Date'), 'yyyy-MM-dd'), to_date(col('Safety_Date'), 'yyyy-MM-dd'))) <= 3))",
    timestamp: '2025-06-25 08:55:29.812654',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Water_Date_In_Month',
    timestamp: '2025-06-25 08:55:29.824876',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Water_Date_In_Month',
    timestamp: '2025-06-25 08:55:29.837855',
  },
  {
    type: 'default',
    message: '    🔧 Refining rule (Quality: 0.09%)',
    timestamp: '2025-06-25 08:55:42.205645',
  },
  {
    type: 'default',
    message: '    📝 Refined rule: Water_Date_In_Month_Refined',
    timestamp: '2025-06-25 08:55:43.818728',
  },
  {
    type: 'default',
    message:
      "    New code: result_df = df.filter(to_date(col('Water_Date'), 'dd-MM-yyyy').isNotNull() & (date_format(to_date(col('Water_Date'), 'dd-MM-yyyy'), 'yyyy-MM') == col('Month')))",
    timestamp: '2025-06-25 08:55:43.834351',
  },
  {
    type: 'default',
    message: '    New description: Ensure Water_Date is valid and falls within the specified Month and Year.',
    timestamp: '2025-06-25 08:55:43.848895',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Water_Date_In_Month_Refined',
    timestamp: '2025-06-25 08:55:43.862861',
  },
  {
    type: 'default',
    message: '    ⚠️  Quality score is 100% for rule: Water_Date_In_Month_Refined. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:55:56.447233',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:55:56.603191',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:55:56.634102',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:56:10.383812',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Water_Date_In_Month_Refined',
    timestamp: '2025-06-25 08:56:10.466276',
  },
  {
    type: 'rule',
    message: 'Ensure Water_Date is valid and falls within the specified Month and Year.',
    timestamp: '2025-06-25 08:56:10.483136',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter(to_date(col('Water_Date'), 'dd-MM-yyyy').isNotNull() & (date_format(to_date(col('Water_Date'), 'dd-MM-yyyy'), 'yyyy-MM') == col('Month')))",
    timestamp: '2025-06-25 08:56:10.496658',
  },
  {
    type: 'default',
    message: '\n📋 Processing column: Waste_Disposal_Method',
    timestamp: '2025-06-25 08:56:10.508735',
  },
  {
    type: 'default',
    message: '  🤖 Generating rules for column: Waste_Disposal_Method',
    timestamp: '2025-06-25 08:56:52.885189',
  },
  {
    type: 'default',
    message: '  📝 Generated 3 rules for Waste_Disposal_Method',
    timestamp: '2025-06-25 08:56:56.202078',
  },
  {
    type: 'default',
    message:
      '  - Waste_Disposal_Method Length Check: Validates that the Waste_Disposal_Method column is not empty and does not exceed a reasonable maximum length.:',
    timestamp: '2025-06-25 08:56:56.218135',
  },
  {
    type: 'default',
    message:
      '  - Waste_Type and Disposal Method Consistency Check: Ensures that Waste_Disposal_Method is consistent with Waste_Type column values.:',
    timestamp: '2025-06-25 08:56:56.232516',
  },
  {
    type: 'default',
    message:
      '  - Safety Date Format Check: Validates the format of Safety_Date column related to Waste_Disposal_Method data, ensuring it follows DD-MM-YYYY format.:',
    timestamp: '2025-06-25 08:56:56.246747',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Disposal_Method Length Check',
    timestamp: '2025-06-25 08:56:56.259877',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Disposal_Method Length Check',
    timestamp: '2025-06-25 08:56:56.273045',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Disposal_Method Length Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:57:05.868037',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:57:05.953073',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:57:05.966485',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is intended to check that the 'Waste_Disposal_Method' column is not empty and does not exceed a maximum length of 50. However, the implementation logic is flawed because it filters for rows where the length is exactly 0 or greater than 50, which means it identifies these rows as faulty, but doesn't actually enforce any constraint or provide actionable information about the column being valid or not. Additionally, based on the data characteristics provided, the column has a null percentage of 0% and unique values percentage of 0%, which implies all values are the same and valid (all 'Recycler Sale'). Therefore, this rule does not currently provide any meaningful data validation and doesn't align with the observed data properties.",
    timestamp: '2025-06-25 08:57:21.630529',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:57:21.712026',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Disposal_Method Validity Check',
    timestamp: '2025-06-25 08:57:23.093176',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:57:32.398587',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:57:32.483535',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule logic includes checks for null or empty values and length constraints, which are standard checks for string columns; however, the data indicates a null percentage of 0.0% and unique values percentage of 0.0%. This suggests that the column consistently contains the same value ('Recycler Sale'). The rule is neither strict nor lenient considering the current characteristics of the data. Additionally, the null and empty check is redundant given the column's null percentage. The length constraint of 50 characters seems unnecessarily high given the example value 'Recycler Sale', which is much shorter. Therefore, the rule would not be useful for identifying actual data quality issues since it doesn't reflect the current state or requirements of the data.",
    timestamp: '2025-06-25 08:57:48.200588',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:57:48.280910',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Disposal_Method Consistency Check',
    timestamp: '2025-06-25 08:57:49.598777',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 50.0%)',
    timestamp: '2025-06-25 08:57:57.337750',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Waste_Disposal_Method Consistency Check' - quality score below 80%",
    timestamp: '2025-06-25 08:57:57.467176',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 08:57:57.481448',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 08:57:57.496039',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Type and Disposal Method Consistency Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:58:07.062413',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:58:07.157648',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:58:07.174985',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule aims to filter rows where Waste_Type is 'Non-Hazardous' and Waste_Disposal_Method is not 'Recycler Sale'. However, the example values for Waste_Disposal_Method are consistently 'Recycler Sale' which indicates that the data might not be diverse enough to apply this rule effectively. Moreover, the description suggests ensuring consistency, but the code filters out inconsistent entries, which might not align with the typical business logic expected for such checks. Additionally, the rule doesn't account for other possible disposal methods for non-hazardous waste but focuses solely on 'Recycler Sale', which may not cover other valid disposal methods.",
    timestamp: '2025-06-25 08:58:22.183178',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:58:22.265252',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Waste_Type and Disposal Method Enhanced Consistency Check',
    timestamp: '2025-06-25 08:58:24.645711',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Type and Disposal Method Enhanced Consistency Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:58:33.165115',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:58:33.286354',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:58:33.309006',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule checks whether 'Waste_Disposal_Method' aligns with acceptable methods for 'Non-Hazardous Waste_Type'. However, the example values provided show that 'Recycler Sale' is overwhelmingly used as the disposal method, while the code logic excludes 'Recycler Sale' as a valid disposal method for 'Non-Hazardous' waste. This is contrary to the real data, indicating a potential mismatch between the rule's logic and the actual data characteristics. Additionally, it only checks for acceptance of four specific disposal methods, which may be too restrictive and not account for other valid methods.",
    timestamp: '2025-06-25 08:58:47.344687',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:58:47.430367',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 08:58:49.260861',
  },
  {
    type: 'default',
    message:
      '    ⚠️  Quality score is 100% for rule: Waste_Type and Disposal Method Consistency Check. This might indicate a weak rule.',
    timestamp: '2025-06-25 08:58:56.915449',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 100.0%',
    timestamp: '2025-06-25 08:58:57.050051',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:58:57.067954',
  },
  {
    type: 'default',
    message: '    ✅ Rule finalized with quality score: 100.0% and passed common sense check',
    timestamp: '2025-06-25 08:59:12.304666',
  },
  {
    type: 'default',
    message: '  ✅ Finalized rule: Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 08:59:12.383942',
  },
  {
    type: 'rule',
    message:
      "Ensures consistency by verifying that the Waste_Disposal_Method aligns with acceptable methods for Non-Hazardous Waste_Type, including a wider range of disposal methods like 'Recycler Sale'.",
    timestamp: '2025-06-25 08:59:12.398914',
  },
  {
    type: 'code',
    message:
      "result_df = df.filter((col('Waste_Type') == 'Non-Hazardous') & (~col('Waste_Disposal_Method').isin(['Recycler Sale', 'Landfill', 'Composting', 'Incineration', 'Reuse', 'Donation', 'Recovery', 'Biogas', 'Water Treatment', 'Phytoremediation'])))",
    timestamp: '2025-06-25 08:59:12.413342',
  },
  {
    type: 'default',
    message: '  🔍 Processing rule: Safety Date Format Check',
    timestamp: '2025-06-25 08:59:12.428258',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 1 for rule: Safety Date Format Check',
    timestamp: '2025-06-25 08:59:12.441838',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.85%',
    timestamp: '2025-06-25 08:59:29.156891',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:59:29.294208',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is meant to validate the format of a date in the Safety_Date column, but it is instead applied to the Waste_Disposal_Method column. The Waste_Disposal_Method column contains string values such as 'Recycler Sale', which do not conform to any date format. Therefore, the rule logic does not make sense for this particular column type and data. Furthermore, the rule description does not match what the code is doing, creating a logical inconsistency.",
    timestamp: '2025-06-25 08:59:46.022520',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 08:59:46.106210',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 2 for rule: Safety Date Format Check',
    timestamp: '2025-06-25 08:59:47.307567',
  },
  {
    type: 'default',
    message: '    ✅ Rule achieved quality score: 99.85%',
    timestamp: '2025-06-25 08:59:57.431362',
  },
  {
    type: 'default',
    message: '    🧠 Validating rule common sense...',
    timestamp: '2025-06-25 08:59:57.562972',
  },
  {
    type: 'default',
    message:
      "    ⚠️ Rule failed common sense check: The rule is intended to validate the format of the 'Safety_Date' column, but it is applied to the 'Waste_Disposal_Method' column according to the context provided. 'Waste_Disposal_Method' contains string values related to disposal methods, not date formats, which makes the rule irrelevant and nonsensical for the data in its current form. Additionally, the code filters based on a date format, which is not applicable to the sample values of 'Recycler Sale'.",
    timestamp: '2025-06-25 09:00:14.023982',
  },
  {
    type: 'default',
    message: '    🔧 Attempting to fix rule based on common sense feedback...',
    timestamp: '2025-06-25 09:00:14.108734',
  },
  {
    type: 'default',
    message: '    🔄 Iteration 3 for rule: Refined Safety Date Format Check',
    timestamp: '2025-06-25 09:00:15.417654',
  },
  {
    type: 'default',
    message: '    ❌ Rule failed to meet quality threshold after 3 iterations (Score: 0.15%)',
    timestamp: '2025-06-25 09:00:24.576258',
  },
  {
    type: 'default',
    message: "    🗑️  Ignoring rule 'Refined Safety Date Format Check' - quality score below 80%",
    timestamp: '2025-06-25 09:00:24.713588',
  },
  {
    type: 'default',
    message: '\n🎯 Total finalized rules: 29',
    timestamp: '2025-06-25 09:00:24.728614',
  },
  {
    type: 'default',
    message: '✅ ColumnWiseRuleGeneratorAgent: Generated 29 rules successfully',
    timestamp: '2025-06-25 09:00:24.739203',
  },
  {
    type: 'default',
    message: '✅ ColumnWiseRuleGeneratorAgent generated 29 rules',
    timestamp: '2025-06-25 09:00:24.752865',
  },
  {
    type: 'default',
    message: '🚀 Delegating to SparkExecutorAgent...',
    timestamp: '2025-06-25 09:00:24.767712',
  },
  {
    type: 'default',
    message: '⚡ SparkExecutorAgent: Executing 29 rules on DataFrame',
    timestamp: '2025-06-25 09:00:24.782102',
  },
  {
    type: 'default',
    message: '🚀 Executing 29 rules using Spark...',
    timestamp: '2025-06-25 09:00:24.797914',
  },
  {
    type: 'default',
    message: '  Progress: 1/29 - EnergyRecordId_UniqueValidation',
    timestamp: '2025-06-25 09:00:24.862280',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: EnergyRecordId_UniqueValidation',
    timestamp: '2025-06-25 09:00:24.879841',
  },
  {
    type: 'default',
    message: '  Progress: 2/29 - Energy_Facility_Length_Validation',
    timestamp: '2025-06-25 09:00:39.555866',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Facility_Length_Validation',
    timestamp: '2025-06-25 09:00:39.639628',
  },
  {
    type: 'default',
    message: '  Progress: 3/29 - Energy_Facility_Consistency_with_Material_type',
    timestamp: '2025-06-25 09:00:40.182309',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Facility_Consistency_with_Material_type',
    timestamp: '2025-06-25 09:00:40.194802',
  },
  {
    type: 'default',
    message: '  Progress: 4/29 - Energy_Type Enum Validation',
    timestamp: '2025-06-25 09:00:40.816870',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Type Enum Validation',
    timestamp: '2025-06-25 09:00:40.829011',
  },
  {
    type: 'default',
    message: '  Progress: 5/29 - Consistent Energy_Fuel_Type for Fuel Consumption',
    timestamp: '2025-06-25 09:00:41.080288',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Consistent Energy_Fuel_Type for Fuel Consumption',
    timestamp: '2025-06-25 09:00:41.094396',
  },
  {
    type: 'default',
    message: '  Progress: 6/29 - Refined Energy_Type and Scope Validation',
    timestamp: '2025-06-25 09:00:41.312696',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Refined Energy_Type and Scope Validation',
    timestamp: '2025-06-25 09:00:41.327803',
  },
  {
    type: 'default',
    message: '  Progress: 7/29 - Refined Unique Energy Record Check',
    timestamp: '2025-06-25 09:00:41.850644',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Refined Unique Energy Record Check',
    timestamp: '2025-06-25 09:00:41.866215',
  },
  {
    type: 'default',
    message: '  Progress: 8/29 - Energy_Value_Is_Numeric',
    timestamp: '2025-06-25 09:00:42.695751',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Value_Is_Numeric',
    timestamp: '2025-06-25 09:00:42.711821',
  },
  {
    type: 'default',
    message: '  Progress: 9/29 - Energy_Value_NonNull',
    timestamp: '2025-06-25 09:00:43.291646',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Value_NonNull',
    timestamp: '2025-06-25 09:00:43.307518',
  },
  {
    type: 'default',
    message: '  Progress: 10/29 - Energy_Unit_Validation',
    timestamp: '2025-06-25 09:00:43.478981',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Unit_Validation',
    timestamp: '2025-06-25 09:00:43.495004',
  },
  {
    type: 'default',
    message: '  Progress: 11/29 - Energy_Unit_Column_Length_Validation',
    timestamp: '2025-06-25 09:00:43.707244',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Unit_Column_Length_Validation',
    timestamp: '2025-06-25 09:00:43.719298',
  },
  {
    type: 'default',
    message: '  Progress: 12/29 - Month Format Validation',
    timestamp: '2025-06-25 09:00:43.969364',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Month Format Validation',
    timestamp: '2025-06-25 09:00:43.982602',
  },
  {
    type: 'default',
    message: '  Progress: 13/29 - Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 09:00:44.586147',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Energy_Source_Consistency_With_Water_Source',
    timestamp: '2025-06-25 09:00:44.602985',
  },
  {
    type: 'default',
    message: '  Progress: 14/29 - Gas_Null_Check',
    timestamp: '2025-06-25 09:00:45.215693',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Gas_Null_Check',
    timestamp: '2025-06-25 09:00:45.229102',
  },
  {
    type: 'default',
    message: '  Progress: 15/29 - Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 09:00:45.364188',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Refined Scope and Gas Consistency Check',
    timestamp: '2025-06-25 09:00:45.377576',
  },
  {
    type: 'default',
    message: '  Progress: 16/29 - Measurement_Method Valid Scope',
    timestamp: '2025-06-25 09:00:45.805711',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Measurement_Method Valid Scope',
    timestamp: '2025-06-25 09:00:45.819133',
  },
  {
    type: 'default',
    message: '  Progress: 17/29 - Fuel Type Enum Validation - Refined',
    timestamp: '2025-06-25 09:00:46.066944',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Fuel Type Enum Validation - Refined',
    timestamp: '2025-06-25 09:00:46.112679',
  },
  {
    type: 'default',
    message: '  Progress: 18/29 - Null Value Check',
    timestamp: '2025-06-25 09:00:46.475772',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Null Value Check',
    timestamp: '2025-06-25 09:00:46.490590',
  },
  {
    type: 'default',
    message: '  Progress: 19/29 - Safety_Date_Format_Validation',
    timestamp: '2025-06-25 09:00:46.674171',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Safety_Date_Format_Validation',
    timestamp: '2025-06-25 09:00:46.690990',
  },
  {
    type: 'default',
    message: '  Progress: 20/29 - Safety_Date_Water_Date_Consistency',
    timestamp: '2025-06-25 09:00:47.555018',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Safety_Date_Water_Date_Consistency',
    timestamp: '2025-06-25 09:00:47.568017',
  },
  {
    type: 'default',
    message: '  Progress: 21/29 - Material_type Enum Validation - Refined',
    timestamp: '2025-06-25 09:00:49.949006',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Material_type Enum Validation - Refined',
    timestamp: '2025-06-25 09:00:49.965481',
  },
  {
    type: 'default',
    message: '  Progress: 22/29 - Cross_Column_Consistency_NonHazardous_Waste_Disposal',
    timestamp: '2025-06-25 09:00:50.489561',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Cross_Column_Consistency_NonHazardous_Waste_Disposal',
    timestamp: '2025-06-25 09:00:50.504903',
  },
  {
    type: 'default',
    message: '  Progress: 23/29 - Refined_Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 09:00:50.810175',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Refined_Waste_Category_Disposal_Method_Consistency',
    timestamp: '2025-06-25 09:00:50.822465',
  },
  {
    type: 'default',
    message: '  Progress: 24/29 - Water_Source_Not_Null_Check',
    timestamp: '2025-06-25 09:00:51.144815',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Water_Source_Not_Null_Check',
    timestamp: '2025-06-25 09:00:51.157072',
  },
  {
    type: 'default',
    message: '  Progress: 25/29 - Water_Source_Enum_Validation',
    timestamp: '2025-06-25 09:00:51.372621',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Water_Source_Enum_Validation',
    timestamp: '2025-06-25 09:00:51.384672',
  },
  {
    type: 'default',
    message: '  Progress: 26/29 - Water_Date_Format_Validation',
    timestamp: '2025-06-25 09:00:51.751442',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Water_Date_Format_Validation',
    timestamp: '2025-06-25 09:00:51.764844',
  },
  {
    type: 'default',
    message: '  Progress: 27/29 - Refined_Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 09:00:52.316548',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Refined_Updated_Water_Date_Matches_Safety_Date',
    timestamp: '2025-06-25 09:00:52.329169',
  },
  {
    type: 'default',
    message: '  Progress: 28/29 - Water_Date_In_Month_Refined',
    timestamp: '2025-06-25 09:00:59.619681',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Water_Date_In_Month_Refined',
    timestamp: '2025-06-25 09:00:59.715392',
  },
  {
    type: 'default',
    message: '  Progress: 29/29 - Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 09:01:02.886026',
  },
  {
    type: 'default',
    message: '  🔍 Executing Spark rule: Waste_Type and Disposal Method Consistency Check',
    timestamp: '2025-06-25 09:01:02.902499',
  },
  {
    type: 'default',
    message: '✅ SparkExecutorAgent: Executed 29 rules successfully',
    timestamp: '2025-06-25 09:01:03.355187',
  },
  {
    type: 'default',
    message: '✅ SparkExecutorAgent executed 29 rules',
    timestamp: '2025-06-25 09:01:03.370347',
  },
  {
    type: 'default',
    message: '📊 Delegating report generation to ColumnWiseRuleGeneratorAgent...',
    timestamp: '2025-06-25 09:01:03.385666',
  },
  {
    type: 'default',
    message: '📊 Generating quality report using Spark...',
    timestamp: '2025-06-25 09:01:03.402970',
  },
  {
    type: 'default',
    message:
      'JSON file uploaded successfully to s3://IOCL/BrsrReporting2025/xlsx2dwhEsgMonthly/output/Agentic_report/data_quality_report.json',
    timestamp: '2025-06-25 09:01:03.671787',
  },
  {
    type: 'default',
    message: '✅ Quality assessment complete. Report saved: data_quality_report.json',
    timestamp: '2025-06-25 09:01:03.689079',
  },
  {
    type: 'default',
    message: '============================================================',
    timestamp: '2025-06-25 09:01:03.733428',
  },
  {
    type: 'default',
    message: '📊 Dataset Profile:',
    timestamp: '2025-06-25 09:01:03.747507',
  },
  {
    type: 'default',
    message: '\n🎉 Big Data Quality Assessment Completed Successfully!',
    timestamp: '2025-06-25 09:01:03.703723',
  },
  {
    type: 'default',
    message: '   • Total Columns: 19',
    timestamp: '2025-06-25 09:01:03.762239',
  },
  {
    type: 'default',
    message: '   • Total Rules Generated: 29',
    timestamp: '2025-06-25 09:01:03.780800',
  },
  {
    type: 'default',
    message: '   • Rules per Column (avg): 1.5',
    timestamp: '2025-06-25 09:01:03.794357',
  },
  {
    type: 'default',
    message: '   • Average Quality Score: 93.2%',
    timestamp: '2025-06-25 09:01:03.808397',
  },
  {
    type: 'default',
    message: '📁 Quality Report: data_quality_report.json',
    timestamp: '2025-06-25 09:01:03.822132',
  },
  {
    type: 'default',
    message: '\n📋 Column Processing Summary:',
    timestamp: '2025-06-25 09:01:03.835179',
  },
  {
    type: 'default',
    message: '    1. Energy_record_id     | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.849503',
  },
  {
    type: 'default',
    message: '    2. Energy_Facility      | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.863418',
  },
  {
    type: 'default',
    message: '    3. Energy_Type          | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.877497',
  },
  {
    type: 'default',
    message: '    4. Energy_Fuel_Type     | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.891185',
  },
  {
    type: 'default',
    message: '    5. Energy_Value         | Type: string   | Nulls:   5.3%',
    timestamp: '2025-06-25 09:01:03.905523',
  },
  {
    type: 'default',
    message: '    6. Energy_Unit          | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.922795',
  },
  {
    type: 'default',
    message: '    7. Month                | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.938424',
  },
  {
    type: 'default',
    message: '    8. Energy_Source        | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:03.952425',
  },
  {
    type: 'default',
    message: '    9. Gas                  | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:03.967203',
  },
  {
    type: 'default',
    message: '   10. Scope                | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:03.980609',
  },
  {
    type: 'default',
    message: '   11. Measurement_Method   | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:03.996425',
  },
  {
    type: 'default',
    message: '   12. Iocl_Fuel_Type       | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:04.010866',
  },
  {
    type: 'default',
    message: '   13. Safety_Date          | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:04.025059',
  },
  {
    type: 'default',
    message: '   14. Material_type        | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:04.038790',
  },
  {
    type: 'default',
    message: '   15. Waste_Type           | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:04.054065',
  },
  {
    type: 'default',
    message: '   16. Waste_Category       | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:04.066411',
  },
  {
    type: 'default',
    message: '   17. Water_Source         | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:04.079026',
  },
  {
    type: 'default',
    message: '   18. Water_Date           | Type: string   | Nulls:   0.1%',
    timestamp: '2025-06-25 09:01:04.092359',
  },
  {
    type: 'default',
    message: '   19. Waste_Disposal_Method | Type: string   | Nulls:   0.0%',
    timestamp: '2025-06-25 09:01:04.105375',
  },
];
